
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import Breadcrumb from "@/components/layout/breadcrumb.vue";
import CandidateCreateForm, {
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import ExamList, { CompanyIdParam } from "@/lib/model/exam/exam";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import Auth from "@/lib/common/auth";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import AddOneCandidateModal from "./components/add-one-candidate-new.vue";
import _, { before, templateSettings } from "lodash";
import AuditCandidate from "./components/audit-candidate.vue";
import AddCandidateTags from "./components/add-candidate-tags.vue";
import Candidate, {
  CandidateDeleteTags,
  CandidateGet,
  CandidateMCreateParams,
  CandidateMCreateParseParams,
  MDelete,
  SendAsk,
  UpdateCandidate
} from "@/lib/model/exam/candidate";
import Config from "@/config/config";
import ModalHeader from "@/components/modal-header.vue";
import ModalTitle from "@/lib/model/exam/modal-title";
import PaperResult from "./paper-result.vue";
import EditCandidateModal from "./components/edit-candidate.vue";
import dayjs from "dayjs";
import AddMoreCandidateModal from "./components/add-more-candidate-new.vue";
import ShowRepeatModal from "./components/show-repeat-modal.vue";
import AsyncDownloadModal from "./components/async-download-modal.vue";
import CandidateRepeatCreateForm from "@/lib/form/candidate/CandidateRepeatCreateForm";
import CandidateMRepeatCreateForm from "@/lib/form/candidate/CandidateMRepeatCreateForm";
import draggable from "vuedraggable";
import vuexStore from "@/store/vuex-store";
import track from "@/lib/common/track";
import SendBgCheckMessageForm from "@/lib/form/bgcheck/SendBgCheckMessageForm";
import BgCheck from "@/lib/model/bgcheck/bgcheck";
import { CompanyConfig } from "@/lib/common/acm";
import Loading from "../../components/loading.vue";
import ErrorDialog from "../ai-builder/components/delete-dialog.vue";
import NR from "@/lib/model/NRXQ/NRXQ";
import { JudgeResult } from "@/lib/model/exam/result";
import Job, { JobInfo, WhiteUser, CommonParam, JobExam } from "@/lib/job/job";
import request from "@/lib/request/request";
import { EnumTagColor, EnumTagMap, EnumTagType } from "@/lib/enum/tags";
import Decrypt from "@/lib/model/decryptParams/decryptParams";
import { replaceBgCheckString } from "@/utils/common";
import BatchFilterCandidate from "./components/batch-filter-candidate.vue";
import ExportDataDrawer from "./components/export-data-drawer.vue";
import ExportVideoDrawer from "./components/export-video-drawer.vue";
//异常项
enum errorEnum {
  "screenshot" = "候选人面试过程中多次截屏",
  "mobileJoinCount" = "候选人面试过程中多次切屏",
  "replacePerson" = "候选人面试过程中疑似换人",
  "readCheating" = "候选人面试过程中疑似念稿",
  "faceCheck" = "候选人身份认证失败",
  // "bgCheck" = "候选人背调未通过",
  "bgCheckSocial" = "候选人有社会安全风险",
  "bgCheckFinancial" = "候选人有金融风险",
  "finger" = "候选人手部检测未通过",
  "webJump" = "候选人Web作答中疑似切屏",
  "eyeColor" = "候选人辨色检测未通过",
  "faceDetection" = "候选人露脸检测未通过",
  "bgCheckIdentity" = "候选人手机号实名未通过",
  "readingDetection" = "候选人面试过程中疑似念稿",
  "nameIdCheck" = "候选人二要素核验未通过",
  "keyboardSoundDetection" = "候选人面试过程中出现键盘声音"
}
enum errorMessageLevel {
  "原数据",
  "存在低风险",
  "存在中风险",
  "存在高风险",
  "存在异常风险"
}
enum auditTextEnum {
  "待评估",
  "通过",
  "待定",
  "拒绝"
}

class PageSizeOptions {
  value = 10;
}

class Paper {
  name = "";
  classification = 0;
  subExamIdList: any = null;
}

class AuditArr {
  // 候选人评估数量类
  passed = 0;
  pending = 0;
  refused = 0;
  unfinish = 0;
  await = 0;
}

class BgCheckSatus {
  financialRiskStatus = 255;
  identityInfoStatus = 255;
  socialInfoStatus = 255;
}

@Component({
  components: {
    Breadcrumb,
    AddOneCandidateModal,
    EditCandidateModal,
    AuditCandidate,
    AddCandidateTags,
    ModalHeader,
    PaperResult,
    AddMoreCandidateModal,
    ShowRepeatModal,
    draggable,
    Loading,
    AsyncDownloadModal,
    ErrorDialog,
    BatchFilterCandidate,
    ExportDataDrawer,
    ExportVideoDrawer
  }
})
export default class PaperList extends Vue {
  $refs!: { result: HTMLFormElement; multipleTable: HTMLFormElement };
  isYD = false;
  name = "paper-list";
  isShowAddOne = false;
  isShowAddMore = false;
  isShowEdit = false;
  showMarkCallback = false;
  examName = "";
  examRemark = "";
  candidateCreateForm = new CandidateCreateForm();
  candidateRepeatCreateForm = new CandidateRepeatCreateForm();
  candidateRepeatMCreateForm = new CandidateMRepeatCreateForm();
  updateCandidateForm = new UpdateCandidate();
  paperId = "0";
  candidateSubmitStatus = 0; //候选人提交状态
  candidateAuditStatus = 0; //候选人评估状态
  payStatus = 0; //支付状态
  examGetForm = new ExamGetForm();
  candidateListForm = new CandidateListForm();
  repeatCandidateListForm = new CandidateListForm();
  exportAllCandidateListForm = new CandidateListForm(); //导出全部功能表单
  candidateList = [];
  repeatCandidateList = [];
  page = 1;
  paper = new Paper();
  currentPageSize = 10;
  total = 0;
  tableLoading = true;
  showMoreFilter = true;
  aiRecommendStatus: number | string = "";
  candidateTag = [];
  tagList = [];
  showNameOrPhone = "";
  showAuditDialog = false;
  showNotice = false;
  showRepeatInterview = false;
  showCandidateDel = false;
  showCandidateRealDel = false;
  showMSendMessage = false;
  isAllowNotice = 0;
  hasLoginCandidate = false;
  onlyShowSelf = false; // 是否只看自己邀请的候选人
  V = vuexStore;
  showMDelete = false;
  mDeleteParam = new SendAsk();
  noticeCandidateId = 0;
  noticeCandidateStatus = 0;
  markCallbackStatus = 0; // ATS面试结果回调状态
  allCandidateNum = 0; // 全部参与人数
  waitAuditNum = 0; // 待评估人数
  finishAuditNum = 0; //  已评估人数
  unfinishNum = 0; // 未完成人数
  answeringNum = 0; //   答题中人数
  notansweringNum = 0; // 未答题人数（未登记 + 已登记）
  finishAuditPassNum = 0; // 已评估通过人数
  finishAuditWaitNum = 0; // 已评估待定人数
  finishAuditRefuseNum = 0; // 已评估拒绝人数
  auditArr = new AuditArr();
  selectedList: any = [];
  selectedIdList: number[] = [];
  multiAudit = false;
  showAddTag = false;
  showSetting = false;
  showSortSetting = false;

  replaceBgCheckString = replaceBgCheckString;

  msgPickerOptions = {
    disabledDate: (date: any) => {
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
    }
  };
  isClearable = false;
  tableHeaderChange = false;
  isShowRepeatModal = false; //点击“重复”标记出现的同一个候选人答题列表
  // 表头信息存储 key
  TableHeaderCachePrefiex = "TABLE_N_FI";
  modalTitle = new ModalTitle();
  deleteTagsForm = new CandidateDeleteTags();
  // 弹窗筛选表头
  headerList: StructParam[] = new Array<StructParam>();
  // 实际展示的表头
  showHeaderList: StructParam[] = new Array<StructParam>();
  // 弹窗筛选临时表头
  tempHeaderList: StructParam[] = new Array<StructParam>();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  companyIdParam = new CompanyIdParam();
  candidateGetForm = new CandidateGet();
  isEnableAi = false;
  isEnableBgCheck = 0;
  delDesc = "";
  currentListLength = 0;
  // 表格全选数量
  candidateIdsLength = 0;
  draggableList: any = []; // 可拖拽表头数据list
  repeatCreateFlag = 1; //单个邀请或者多个邀请 1单个 2多个
  showBgCheck = false; // 背景调查弹窗
  bgCheckMessageStatus = 0; // 背调通知状态
  checkStatus = 0; // 背调总状态
  bgCheckStatus: BgCheckSatus = new BgCheckSatus();
  sendBgCheckMessageForm: SendBgCheckMessageForm = new SendBgCheckMessageForm();
  examTypeFlag = true; // 考试类型，值为test的时候，去掉得分和AI得分
  disableBgcheck = false; //去掉背调结果，新需求调整
  pageSizeOptions: PageSizeOptions[] = [
    { value: 10 },
    { value: 20 },
    { value: 50 },
    { value: 100 }
  ];
  pickerOptions = {
    // disabledDate: (time: any) => {
    //   console.log(new Date(time).getTime())
    //   return new Date(time).getTime() < Date.now()
    // }
  };
  rowStyle = {
    color: "#8B8F94",
    "font-weight": "400",
    "font-size": "14px"
  };
  sideCol = true; //侧边栏收起
  sideStatus = ""; //侧边栏状态
  superMark = false; //数据标注权
  showAddCandidateBtn = false; //是否展示添加候选人按钮
  loadingList = true;
  selectedAllFlag = false; // 是否选择了全部
  isShowDownloadModal = false;
  selectedListStr = "";
  showErrorInfo = false;
  showWarningIcon = false;
  showErrorTitle = "异常情况说明";
  errorText = "";
  city1 = "";
  city2 = "";
  job = "";
  cityListFilter: string[] = [];
  cityListFilter2: string[] = [];
  cityList = [
    "不限",
    "北京 北京",
    "天津 天津",
    "河北 廊坊",
    "湖北 武汉",
    "湖北 宜昌",
    "湖北 黄石",
    "吉林 长春",
    "江苏 苏州",
    "江苏 南京",
    "江苏 南通",
    "江苏 昆山",
    "江苏 无锡",
    "江苏 常州",
    "江西 南昌",
    "辽宁 大连",
    "辽宁 沈阳",
    "山西 太原",
    "陕西 西安",
    "上海 上海",
    "浙江 杭州",
    "浙江 宁波",
    "浙江 金华",
    "浙江 嘉兴",
    "福建 福州",
    "福建 厦门",
    "福建 宁德",
    "福建 泉州",
    "福建 福鼎",
    "广东 深圳",
    "广东 广州",
    "广东 东莞",
    "广东 汕头",
    "广东 湛江",
    "广东 惠州",
    "广东 珠海",
    "广东 韶关",
    "广东 佛山",
    "广东 英德",
    "广东 清远",
    "广东 肇庆",
    "广东 河源",
    "广东 茂名",
    "广东 中山",
    "江西 赣州",
    "广西 南宁",
    "广西 桂林",
    "广西 柳州",
    "贵州 贵阳",
    "四川 攀枝花",
    "四川 成都",
    "四川 绵阳",
    "四川 宜宾",
    "云南 普洱",
    "云南 昆明",
    "云南 曲靖",
    "重庆 重庆",
    "湖南 长沙",
    "江西 新余"
  ];
  jobList = [
    "不限",
    "间接采购",
    "财务部",
    "地产发展-战略规划",
    "地产发展-项目",
    "供应链（直接进口物流）",
    "供应链（库存管理）",
    "山姆市场/会籍/电商部",
    "供应链（电商物流）",
    "大卖场采购部",
    "人力资源部",
    "大卖场电商",
    "大卖场市场部",
    "全球业务中心（GBS）",
    "B2B&零售金融",
    "山姆采购部"
  ];
  //展示选择意向城市的面试
  showCitySelectPaperIdList = [
    2461,
    2464,
    2631,
    2632,
    2718,
    3592,
    3593,
    3594,
    3595,
    3612,
    3613,
    3614,
    3615,
    3616,
    3617,
    3618,
    3619,
    3620,
    3621,
    3622,
    3623,
    3624,
    3625,
    3626,
    3627,
    3628,
    3629,
    3630,
    3631,
    3632,
    3633,
    3634,
    3635,
    3636,
    3637,
    3642,
    3643,
    3664
  ];

  // isWorker = false;
  //结果权限
  resultPowerList = [
    "AI打分",
    "AI推荐",
    "评估结果",
    "得分",
    "面试官评分",
    "AI评估说明",
    "面试官结果"
  ];
  //其他权限  list以外的都算
  otherPowerList = [
    "姓名",
    "姓名/手机",
    "手机",
    "邮箱",
    "身份证号",
    "新建时间",
    "面试状态",
    "通知状态",
    "提交时间",
    "交卷方式",
    "负责人",
    "身份证号",
    "身份证",
    "身份证号后6位",
    "AI打分",
    "AI推荐",
    "评估结果",
    "得分",
    "面试官评分",
    "AI评估说明",
    "面试官结果"
  ];
  fskTimeSearch = 1; //富士康时间搜索
  todayPeopleAll = 0; //fsk今日人数
  subExamList: any = []; // 关联子卷
  subExam: string | number = "";
  showSecondAskDialog = false; // 二次确认提示
  dialogSendTitle = "选择全部";
  dialogSendConcent = "";

  // 批量筛选候选人：打开弹框
  showBatchFilter = false;
  onShowBatchFilter() {
    this.showBatchFilter = true;
  }

  connectCodeList: string[] = [];

  // 抽屉状态管理
  showDataDrawer = false; // 候选人综合数据抽屉显示状态
  showVideoDrawer = false; // 候选人答题明细抽屉显示状态
  showExportDrawer = false; // 导出数据抽屉显示状态
  preloadedHeaders: any[] = []; // 预加载的表头数据
  preloadedAnswerHeaders: any[] = []; // 预加载的答题明细表头数据
  exportMode: "selected" | "all" = "selected"; // 导出模式：selected选中导出，all全部导出

  // 批量筛选候选人：确认
  handleBatchFilterConfirm(connectCodeList: string[] = []) {
    this.$message.success(`已提交${connectCodeList.length}条编码进行筛选`);
    this.connectCodeList = connectCodeList;
    this.getCandidateList("toFirst");
  }

  // 批量筛选候选人：清空
  onClearConnectCodeList() {
    this.connectCodeList = [];
    this.getCandidateList("toFirst");
  }

  async share(row: any) {
    console.log(row);
    let text = "";
    let url = await this.getReportUrl(row);
    //拼上host
    url = `${location.origin}${url}`;
    text = row.reportCertiCode
      ? `链接：${url}  提取码：${row.reportCertiCode}`
      : url;
    try {
      await navigator.clipboard.writeText(text);
      this.$message({
        message: "复制成功",
        type: "success"
      });
      console.log("文本已成功复制到剪切板");
    } catch (err) {
      console.error("无法复制文本: ", err);
    }
  }

  // 因为服务器的压力，用户疯狂点击查询全部信息，数据库压力很大。限制了返回的总数， 超过9999的都显示9999+
  get totalShow() {
    let totalLimit = 9999;
    if (process.env.NODE_ENV === "production") {
      totalLimit = 9999;
    }
    if (this.total >= totalLimit) {
      return `${totalLimit}+`;
    } else {
      return this.total;
    }
  }

  // 待评估人数
  get waitAuditNumShow() {
    let totalLimit = 9999;
    if (this.waitAuditNum >= totalLimit) {
      return `${totalLimit}+`;
    } else {
      return this.waitAuditNum;
    }
  }

  async getReportUrl(row: any) {
    let previewUrl = `/candidate-info?connectCode=${
      row.connectCode
    }&companyId=${Auth.companyId}${
      row.subExamId ? "&subExamId=" + row.subExamId : ""
    }`;

    // 加密报告秘钥
    try {
      const sidRes = await NR.getSid({
        companyId: Auth.companyId,
        candidateId: row.candidateId
      });
      previewUrl += "&sid=" + sidRes.sid;
    } catch (error) {
      console.error("获取SID失败", error);
    }

    // 获取报告鉴权tid
    try {
      const tidRes = await Decrypt.get({
        candidateId: String(row.candidateId)
      });
      previewUrl += "&tid=" + tidRes.tid;
    } catch (error) {
      console.error("获取TID失败", error);
    }

    return previewUrl;
  }

  @Watch("side") //底部按钮位移动画
  sideChanged(n: boolean) {
    this.sideCol = n;
    this.sideStatus = n ? "in" : "out";
  }
  //存一下筛选条件
  @Watch("candidateListForm", {
    immediate: true,
    deep: true
  })
  candidateListFormChange(n: CandidateListForm) {
    // this.V.updateCandidateParams(n);
    // sessionStorage.setItem("candidateParams", JSON.stringify(n));
  }
  @Watch("candidateAuditStatus", {})
  ss(n: any, o: any) {
    if (n > 0 && !this.isYD) {
      this.candidateSubmitStatus = 2;
    }
  }

  get fuzzySearch() {
    return CompanyConfig.getInstance().fuzzySearch === 1;
  }

  get useMultiTag() {
    return CompanyConfig.getInstance().useMultiTag === 1;
  }

  get showCitySelect() {
    return CompanyConfig.getInstance().showCitySelect === 1;
  }

  get side() {
    return vuexStore.sideIsCollapse;
  }
  get isWorker() {
    // return (
    //   [90528, 91359, 91237, 91415, 1010, 173, 194].includes(
    //     Number(Auth.companyId) ?? 0
    //   ) || CompanyConfig.getInstance().isTestExamCompany === 1
    // );
    return this.V.isWorker;
  }
  //面试状态选了未交卷的 用于锁住阅卷入口
  get selectNoSubmit() {
    return (
      this.candidateListForm.submitStatusList.length > 0 &&
      this.candidateListForm?.submitStatusList?.[0] !== 2
    );
  }

  //内部使用 设置web页
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  // 定时发送消息0630
  get setTimeSendMessage() {
    return (
      !this.isWorker &&
      [92145, 80978, 91353].includes(Number(this.V.company.id))
    );
  }

  changeTimePickerGetForm(str: string) {
    // eldatepicker点击此刻没给抛出时间，只能自己搞一个了。。。
    const time = new Date(str).getTime();
    const now = Date.now();
    if (time + 1000 > now && time - 1000 < now) {
      // 误差在1秒之内认为点击了此刻按钮，清空
      this.candidateGetForm.sendMessageTime = "";
    }
  }

  changeTimePickerDeleteParam(str: string) {
    // eldatepicker点击此刻没给抛出时间，只能自己搞一个了。。。
    const time = new Date(str).getTime();
    const now = Date.now();
    if (time + 1000 > now && time - 1000 < now) {
      // 误差在1秒之内认为点击了此刻按钮，清空
      this.mDeleteParam.sendMessageTime = "";
    }
  }

  className(submitStatus: number, auditStatus: number) {
    if (submitStatus === 0) {
      return "submit-color-1";
    } else if (submitStatus === 1) {
      return "submit-color-2";
    } else if (submitStatus === 3) {
      return "submit-color-1";
    } else if (submitStatus === 2) {
      return "submit-color-3";
    } else if (submitStatus === 5) {
      return "audit-color-1";
    } else if (submitStatus === 4) {
      return "audit-color-1";
    } else {
      if (auditStatus === 0) {
        return "audit-color-1";
      } else if (auditStatus === 1) {
        return "audit-color-2";
      } else if (auditStatus === 2) {
        return "audit-color-3";
      } else if (auditStatus === 3) {
        return "audit-color-4";
      } else {
        return "audit-color-1";
      }
    }
  }

  classNameFsk(submitStatus: number) {
    if (submitStatus == 0) {
      // 默认 黄色
      return "submit-color-2";
    } else if (submitStatus == 10) {
      // 未答题 灰色
      return "submit-color-1";
    } else if (submitStatus == 20) {
      // 无资格 黄色
      return "submit-color-2";
    } else if (submitStatus == 30) {
      // 未完成 黄色
      return "submit-color-2";
    } else if (submitStatus == 40) {
      // 已交卷 绿色
      return "submit-color-3";
    } else {
      return "submit-color-2";
    }
  }

  get getTimeOptions() {
    const today = dayjs(new Date()).format("YYYY-MM-DD");
    const todayStartTime = new Date(`${today} 00:00:00`).getTime();
    const endTime = new Date(`${today} 23:59:59`);

    return {
      shortcuts: [
        {
          text: "最近三天",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 2);
            picker.$emit("pick", [start, endTime]);
          }
        },
        {
          text: "最近一周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, endTime]);
          }
        },
        {
          text: "最近两周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 13);
            picker.$emit("pick", [start, endTime]);
          }
        },
        {
          text: "最近一个月",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 29);
            picker.$emit("pick", [start, endTime]);
          }
        }
      ]
    };
  }

  mounted() {
    this.cityListFilter = this.cityList;
    this.cityListFilter2 = this.cityList;
    this.isYD = ["194", "91415"].includes(Auth.companyId);

    this.sideCol = JSON.parse(localStorage.getItem("isCollapse") || "true");

    window.onresize = () => {
      return (() => {
        this.handleLableWidth();
      })();
    };
    this.paperId = this.$route.params.paperId;

    this.currentPageSize =
      parseInt(Auth.currentPageSize) > 0 ? parseInt(Auth.currentPageSize) : 10;
    this.TableHeaderCachePrefiex =
      this.TableHeaderCachePrefiex + "_" + this.paperId;
    const getToken = Auth.token;

    document.addEventListener("mouseup", this.handleMouseUp);

    if (getToken) {
      // this.getTagList();
      console.log("1111");
      this.initialSort();
      this.getExamInfo();
      // this.superMark = res?.isHrMark === 1;
    }
  }

  beforeDestroy() {
    document.removeEventListener("mouseup", this.handleMouseUp);
  }

  // 可拖拽排序的字段过滤，1. 手机号不显示; 2.AI打分仅isEnableAi或者有examTypeFlag标签才显示; 3.考试类型，值为test的时候(examTypeFlag为false)，去掉得分和AI得分; 4.公司为富士康才展示“处理原因”
  get headerListFilterd() {
    return this.headerList.filter((item: any) => {
      return (
        item.name != "手机" &&
        !((!this.isEnableAi || !this.examTypeFlag) && item.isRequired == 8) &&
        !((!this.isEnableAi || !this.examTypeFlag) && item.isRequired == 9) &&
        !(this.isWorker && item.isRequired == 7) && // 为得分且类型为 test
        !(!this.isWorker && item.isRequired == 11) && // 公司为富士康才展示“处理原因”
        !((this.isWorker || this.isYD) && ["user"].includes(item.extraData)) && // 普工版：不展示负责人 面试官评分 面试官结果
        !(
          !this.$P.candidateInfo.result &&
          this.resultPowerList.includes(item.name)
        ) && //数据权限-result
        !(
          !this.$P.candidateInfo.other &&
          !this.otherPowerList.includes(item.name)
        ) //数据权限-other
      );
    });
  }

  // 表头拖拽排序，姓名/手机 不能拖拽
  get onlyShowNameFilterd() {
    return this.headerListFilterd.filter((item: any) => {
      return item.name === "姓名/手机";
    });
  }

  // 表头拖拽排序，除了 ‘姓名/手机’ 均可拖拽
  get draggableFiltered() {
    return this.headerListFilterd.filter((item: any) => {
      return (
        item.name !== "姓名/手机" &&
        item.name !== "姓名" &&
        item.name !== "手机" &&
        !(this.isWorker && ["AI推荐", "AI打分"].includes(item.name))
      );
    });
  }

  get showHeaderListFilterd() {
    return this.showHeaderList.filter((item: any) => {
      return (
        item.name != "手机" &&
        !(!this.isEnableAi && !this.examTypeFlag && item.isRequired == 8) &&
        !(!this.isEnableAi && !this.examTypeFlag && item.isRequired == 9) &&
        //数据权限
        !(
          !this.$P.candidateInfo.result &&
          this.resultPowerList.includes(item.name)
        ) &&
        !(
          !this.$P.candidateInfo.other &&
          !this.otherPowerList.includes(item.name)
        )
      );
    });
  }

  get dragOptions() {
    return {
      animation: 0,
      group: "description",
      ghostClass: "ghost"
    };
  }

  handleMouseUp(event: any) {
    const sp = document.getElementById("show-setting-modal");
    if (sp) {
      if (!sp.contains(event.target)) {
        //业务逻辑
        this.showSortSetting = false;
      }
    }
  }

  handleBgCheckClose() {
    this.showBgCheck = false;
  }

  // 发送背调通知
  sendBgCheckMessage() {
    this.sendBgCheckMessageForm.candidateId = this.noticeCandidateId;
    this.sendBgCheckMessageForm.companyId = parseInt(Auth.companyId);
    this.sendBgCheckMessageForm.userId = parseInt(this.V.user.id);
    BgCheck.SendBgCheckMessage(this.sendBgCheckMessageForm)
      .then(resp => {
        if (resp.code === 0) {
          this.getCandidateList();
        } else {
          this.$message.error(resp.message);
        }
      })
      .finally(() => {
        this.showBgCheck = false;
      });
  }
  //fsk 时间筛选
  getFskTime(d: number) {
    if (d === 1) {
      this.candidateListForm.createdTime = ["", ""];
      this.getCandidateList();
    }
    if (d === 2) {
      this.candidateListForm.createdTime = [
        dayjs(new Date()).format("YYYY-MM-DD") + " 00:00:00",
        dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
      ];
      this.getCandidateList();
    }
  }
  ct1() {
    this.candidateListForm.page = 1;
    this.sensorsTrack("选择创建时间");
    this.getCandidateList();
    this.fskTimeSearch = 0;
  }

  handleLableWidth() {
    console.log("screenEidth: ", window);
    this.showSortSetting = false;
  }

  initialSort() {
    this.candidateListForm.sortKey = "created_time";
    this.candidateListForm.sortDict = "desc";
  }

  getColumnWidth(headerItem: any) {
    switch (headerItem.name) {
      case "年龄":
        return 80;
      case "学历":
        return 100;
      case "性别":
        return 80;
      case "姓名/手机":
        return 270;
      case "手机":
        return 130;
      case "区域经理":
        return 100;
      case "组别经理":
        return 100;
      default:
        return 210;
    }
  }
  getColumnValue(row: any, columnName: any) {
    for (const param of row.paramList) {
      if (param.name === columnName) return param.cascadeValue;
    }
    return "";
  }

  handleMoreClose() {
    this.getCandidateList();
    this.isShowAddOne = false;
    this.isShowAddMore = false;
  }

  handleRepeatClose() {
    this.isShowRepeatModal = false;
  }

  onMove(res: any) {
    const newIndex = res.newIndex; //拖拽选项的新索引
    const oldIndex = res.oldIndex; //拖拽选项的老索引
    const tempShowHeaderList = this.draggableFiltered;
    const minIndex = this.draggableFiltered[0].sort;

    // 修改排序
    tempShowHeaderList[oldIndex].sort = newIndex + minIndex;
    // 上移动,中间的排序 + 1
    if (newIndex < oldIndex) {
      tempShowHeaderList.forEach((sortItem: any, key: number) => {
        if (key >= newIndex && key < oldIndex) {
          tempShowHeaderList[key].sort = sortItem.sort + 1;
        }
      });
    } else if (newIndex > oldIndex) {
      //下移动 中间的排序 - 1
      tempShowHeaderList.forEach((sortItem: any, key: number) => {
        if (key > oldIndex && key <= newIndex) {
          tempShowHeaderList[key].sort = sortItem.sort - 1;
        }
      });
    }
    this.draggableFiltered.sort(function(a: any, b: any) {
      if (a["sort"] < b["sort"]) {
        return -1;
      }
      if (a["sort"] > b["sort"]) {
        return 1;
      }
      return 0;
    });
    this.draggableList = this.draggableFiltered;
    this.$forceUpdate();
  }

  sortCancel() {
    // 加个重置逻辑
    localStorage.setItem(this.TableHeaderCachePrefiex, "");
    this.getExamInfo();
    this.$refs.multipleTable.resetDefaultColumns();
    this.showSortSetting = false;
  }

  sortSubmit() {
    this.tableLoading = true;
    this.showSortSetting = false;
    setTimeout(() => {
      if (this.draggableList.length > 0) {
        this.headerList = this.onlyShowNameFilterd.concat(this.draggableList);
      }
      this.tempHeaderList = this.headerList.filter(item => {
        return Boolean(item.isShow) === true;
      });
      this.headerSubmit();
      this.$forceUpdate();
    }, 600);
    // 神策埋点
    this.selectedListStr = "";
    this.tempHeaderList.forEach((headerItem: any) => {
      this.selectedListStr += headerItem.name + " ";
    });
    track("set_list_head", {
      selected_element: JSON.stringify(this.selectedListStr)
    });
  }

  sensorsTrack(operation_type: string, operation_name = "") {
    if (operation_type == "筛选面试状态") {
      switch (this.candidateSubmitStatus) {
        case 0:
          operation_name = "不限";
          break;
        case 1: //已评估
          operation_name = "已评估";
          break;
        case 2: //待评估
          operation_name = "待评估";
          break;
        case 3: //答题中
          operation_name = "答题中";
          break;
        case 4: //已登记
          operation_name = "已登记";
          break;
        case 5: //未登记
          operation_name = "未登记";
          break;
        default:
          operation_name = "未筛选";
          break;
      }
    } else if (operation_type == "筛选面试结果") {
      switch (this.candidateAuditStatus) {
        case 0:
          operation_name = "不限";
          break;
        case 1:
          operation_name = "通过";
          break;
        case 2:
          operation_name = "待定";
          break;
        case 3:
          operation_name = "拒绝";
          break;
        default:
          operation_name = "未筛选";
          break;
      }
    } else if (operation_type == "搜索候选人/手机号") {
      operation_name = this.showNameOrPhone;
    } else if (operation_type == "选择创建时间") {
      if (this.candidateListForm.createdTime?.length) {
        operation_name =
          this.candidateListForm.createdTime[0] +
          " - " +
          this.candidateListForm.createdTime[1];
      }
    } else if (operation_type == "筛选标签") {
      operation_name = this.candidateTag.join(",");
    } else if (operation_type == "筛选负责人") {
      operation_name = this.V.user.id;
    }
    track("candidate_page_interact", {
      exam_id: this.examGetForm.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      operation_type: operation_type,
      operation_name: operation_name,
      from_page: "没打通的候选人列表页"
    });
    return true;
  }
  delSensorsTrack(operate: string, submit_status: number, candidateId: any) {
    let trick_name = "try_delete_candidate_click";
    if (operate !== "del-click") {
      trick_name = "confirm_delete_candidate_click";
    }
    track(trick_name, {
      exam_id: this.examGetForm.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      operation_type: "点击删除候选人",
      operation_name: submit_status,
      submit_status: submit_status,
      candidate_id: candidateId
    });
  }
  showAdd(event: string) {
    this.modalTitle.desc = this.examName;
    this.candidateMCreateParseParams.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.examId = this.examGetForm.examId;
    this.candidateMCreateParams.examId = String(this.examGetForm.examId);
    this.candidateMCreateParams.companyId = Auth.companyId;
    if (event == "showAddOne") {
      this.sensorsTrack("按钮点击", "添加一位候选人");
      this.modalTitle.title = "添加一位候选人";
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.candidateCreateForm.paramList = res.paramList.filter(
            (e: StructParam) => {
              return e.isShow == 1;
            }
          );
          this.candidateCreateForm.companyId = this.examGetForm.companyId;
          this.candidateCreateForm.examId = this.examGetForm.examId;
        })
        .finally(() => {
          this.isShowAddMore = false;
          this.isShowAddOne = true;
        });
    } else if (event === "showAddMore") {
      this.sensorsTrack("按钮点击", "批量添加候选人");
      this.modalTitle.title = "批量添加候选人";
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }
  getRowKeys(row: any) {
    return row.candidateId;
  }
  async getSubExam() {
    const data = await Job.getAllExam({
      examIdList: this.paper.subExamIdList,
      onlySubExam: 1
    });
    this.subExamList = data.list;
  }
  getExamInfo() {
    this.tableLoading = true;
    this.examGetForm.examId = parseInt(this.paperId);
    this.examGetForm.companyId = parseInt(Auth.companyId);
    ExamList.examGet(this.examGetForm)
      .then(res => {
        this.paper = res;
        if (
          this.paper.classification === 1 &&
          this.paper.subExamIdList.length > 0
        ) {
          this.getSubExam();
        }
        this.examName = res.name;
        this.examRemark = res.remark;
        this.showAddCandidateBtn = res?.closeInviteCandidate !== 1; //隐藏添加候选人
        if (res.companySpecialConfig && res.companySpecialConfig.isEnableAi) {
          this.isEnableAi = res.companySpecialConfig.isEnableAi == 1;
        }
        if (res.examType == "test") {
          this.examTypeFlag = false;
        }
        this.isEnableBgCheck = res.bgCheckProductId > 0 ? 1 : 0;
        this.candidateCreateForm.paramList = res.paramList.filter(
          (e: StructParam) => {
            return e.isShow == 1;
          }
        );
        // this.headerList = res.paramList;
        const getData = localStorage.getItem(this.TableHeaderCachePrefiex);

        // if (getData && parseInt(this.paperId) > 0) {
        //   try {
        //     const data = JSON.parse(getData);
        //     this.headerList = data;
        //     this.showHeaderList = data.filter((item: any) => {
        //       return Boolean(item.isShow) === true || item.name === "姓名/手机";
        //     });
        //     // 判断AI面试是否显示，避免因为缓存导致后太打开AI面试得分之后，前端显示不出的问题
        //     this.showHeaderList.forEach((headItem: any, headKey: number) => {
        //       if (headItem.name === "AI打分") {
        //         this.showHeaderList[headKey].isShow =
        //           this.isEnableAi && this.examTypeFlag ? 1 : 0;
        //       }
        //       if (headItem.name === "背调结果") {
        //         this.showHeaderList[headKey].isShow = this.isEnableBgCheck;
        //       }
        //     });
        //     console.log(this.showHeaderList);
        //   } catch (error) {
        //     this.showHeaderList = this.candidateCreateForm.paramList.filter(
        //       (item, index) => {
        //         return item.isShow == 1;
        //       }
        //     );
        //     // this.showHeaderList[0].name = "姓名/手机";
        //     let sysHeaderList = new Array<StructParam>();
        //     sysHeaderList = this.candidateCreateForm.paramList.filter(
        //       (item, index) => {
        //         return item.isShow == 1;
        //       }
        //     );
        //     sysHeaderList.forEach((showItem: any, showKey: number) => {
        //       if (showItem.name == "姓名") {
        //         sysHeaderList[showKey].name = "姓名/手机";
        //         sysHeaderList[showKey].isShow = 1;
        //       } else {
        //         sysHeaderList[showKey].isShow = 0;
        //       }
        //       sysHeaderList[showKey].sort = showKey;
        //     });
        //     const sysHeader = [
        //       { name: "创建时间", extraData: "cratedTime", isShow: 1, sort: 0 },
        //       {
        //         name: "负责人",
        //         extraData: "user",
        //         isShow: this.isWorker ? 0 : 1,
        //         sort: 0
        //       },
        //       {
        //         name: "通知状态",
        //         extraData: "messageStatus",
        //         isShow: 0,
        //         sort: 0
        //       },
        //       { name: "面试状态", extraData: "submit", isShow: 1, sort: 0 },
        //       {
        //         name: "得分",
        //         extraData: "score",
        //         isShow: 0,
        //         sort: 0
        //       },
        //       {
        //         name: "AI打分",
        //         extraData: "scoreai",
        //         isShow: this.isEnableAi && this.examTypeFlag ? 1 : 0,
        //         sort: 0
        //       },
        //       // { name: "HR评分", extraData: "scoreHrTotal", isShow: 1, sort: 0 },

        //       {
        //         name: "AI推荐",
        //         extraData: "airecomend",
        //         isShow: this.isEnableAi && this.examTypeFlag ? 1 : 0,
        //         sort: 0
        //       },
        //       { name: "评估结果", extraData: "audit", isShow: 1, sort: 0 },
        //       // {
        //       //   name: "背调结果",
        //       //   extraData: "bgcheck",
        //       //   isShow: this.isEnableBgCheck,
        //       //   sort: 0
        //       // },
        //       {
        //         name: "AI评估说明",
        //         extraData: "",
        //         isShow: this.isWorker ? 1 : 0,
        //         sort: 0
        //       },
        //       { name: "标签", extraData: "tags", isShow: 1, sort: 0 }
        //     ];
        //     sysHeader.forEach((headerItem, index) => {
        //       const tempArr = new StructParam();
        //       tempArr.name = headerItem.name;
        //       tempArr.isShow = headerItem.isShow;
        //       tempArr.isRequired = index + 3;
        //       tempArr.sort = this.candidateCreateForm.paramList.length + index;
        //       sysHeaderList.push(tempArr);
        //     });
        //     this.headerList = sysHeaderList; // headerList 表头筛选项
        //     this.showHeaderList = this.headerList.filter(item => {
        //       return Boolean(item.isShow) === true || item.name === "姓名/手机";
        //     }); // showHeaderList 表头显示项
        //   }
        // } else {
        this.showHeaderList = this.candidateCreateForm.paramList.filter(
          (item, index) => {
            return item.isShow == 1;
          }
        );
        // this.showHeaderList[0].name = "姓名/手机";
        let sysHeaderList = new Array<StructParam>();
        sysHeaderList = this.candidateCreateForm.paramList.filter(
          (item, index) => {
            return item.isShow == 1;
          }
        );
        sysHeaderList.forEach((showItem: any, showKey: number) => {
          if (showItem.name == "姓名") {
            sysHeaderList[showKey].name = "姓名/手机";
            sysHeaderList[showKey].isShow = 1;
          } else {
            sysHeaderList[showKey].isShow = 0;
          }
          sysHeaderList[showKey].sort = showKey;
        });
        const commonTag = [
          {
            name: "标签",
            extraData: "tags",
            isShow: 1,
            sort: 0
          }
        ];

        const multiTag = [
          {
            name: "邀请标签",
            extraData: "tagsInvite",
            isShow: 1,
            sort: 0
          },
          {
            name: "评估标签",
            extraData: "tagsAudit",
            isShow: 1,
            sort: 0
          },
          {
            name: "自动化规则标签",
            extraData: "tagsRule",
            isShow: 1,
            sort: 0
          },
          {
            name: "其他标签",
            extraData: "tags",
            isShow: 1,
            sort: 0
          }
        ];
        const sysHeader = [
          { name: "创建时间", extraData: "cratedTime", isShow: 1, sort: 0 },
          {
            name: "负责人",
            extraData: "user",
            isShow: this.isWorker ? 0 : 1,
            sort: 0
          },
          {
            name: "通知状态",
            extraData: "messageStatus",
            isShow: 0,
            sort: 0
          },
          { name: "面试状态", extraData: "submit", isShow: 1, sort: 0 },
          {
            name: "得分",
            extraData: "score",
            isShow: 0,
            sort: 0
          },
          {
            name: "AI打分",
            extraData: "scoreai",
            isShow:
              this.isEnableAi && this.examTypeFlag && !this.isWorker ? 1 : 0,
            sort: 0
          },
          {
            name: "AI推荐",
            extraData: "airecomend",
            isShow:
              this.isEnableAi && this.examTypeFlag && !this.isWorker ? 1 : 0,
            sort: 0
          },
          // { name: "HR评分", extraData: "scoreHrTotal", isShow: 1, sort: 0 },

          { name: "评估结果", extraData: "audit", isShow: 1, sort: 0 },
          // {
          //   name: "背调结果",
          //   extraData: "bgcheck",
          //   isShow: this.isEnableBgCheck,
          //   sort: 0
          // },
          {
            name: "AI评估说明",
            extraData: "",
            isShow: this.isWorker ? 1 : 0,
            sort: 0
          },
          // { name: "标签", extraData: "tags", isShow: 1, sort: 0 },
          ...(this.useMultiTag ? multiTag : commonTag),
          //index 10
          {
            name: "交卷方式",
            isShow: 0,
            extraData: "submitData",
            sort: 0
          },
          // {
          //   name: "面试官评分",
          //   isShow: 0,
          //   sort: 0
          // },
          // {
          //   name: "面试官结果",
          //   isShow: 0,
          //   sort: 0
          // },
          {
            name: "提交时间",
            isShow: 0,
            extraData: "submitTime",
            sort: 0
          },
          {
            name: "邀面时间",
            isShow: 0,
            extraData: "sendMessageTime",
            sort: 108,
            isRequired: 108
          },
          {
            name: "开始答题时间",
            isShow: 0,
            extraData: "beginTime",
            sort: 109
          }
        ];
        if (this.paper.classification === 1) {
          sysHeader.push({
            name: "子卷名称",
            extraData: "subExamName",
            isShow: 1,
            sort: 0
          });
        }
        if (this.setWeb) {
          sysHeader.push({
            name: "ATS面试结果回调",
            extraData: "markCallbackStatus",
            isShow: 1,
            sort: 19
          });
        }
        sysHeader.forEach((headerItem, index) => {
          const tempArr = new StructParam();
          tempArr.name = headerItem.name;
          tempArr.isShow = headerItem.isShow;
          // if (headerItem.name === '子卷名称') {
          //   tempArr.isRequired = 99
          // } else {
          // }
          tempArr.extraData = headerItem.extraData ?? headerItem.name;
          tempArr.isRequired = index + 3;
          tempArr.sort = this.candidateCreateForm.paramList.length + index;
          sysHeaderList.push(tempArr);
        });
        const cacheData = getData ? JSON.parse(getData) : undefined;
        this.headerList = this.genHeaderList(sysHeaderList, cacheData);
        // this.headerList = sysHeaderList; // headerList 表头筛选项
        // //缓存表头 并入
        // if (getData) {
        //   const data = JSON.parse(getData);
        //   data.forEach((d: any) => {
        //     this.headerList.forEach(h => {
        //       if (h.name === d.name) {
        //         h.isShow = d.isShow;
        //         h.sort = d.sort;
        //       }
        //     });
        //   });
        // }
        // //刷下排序
        // this.headerList.sort(function(a: any, b: any) {
        //   if (a["sort"] < b["sort"]) {
        //     return -1;
        //   }
        //   if (a["sort"] > b["sort"]) {
        //     return 1;
        //   }
        //   return 0;
        // });

        this.showHeaderList = this.headerList.filter(item => {
          return Boolean(item.isShow) === true || item.name === "姓名/手机";
        }); // showHeaderList 表头显示项
        // }
        console.log("headerList : ", this.headerList);
        this.candidateCreateForm.companyId = this.examGetForm.companyId;
        this.candidateCreateForm.examId = parseInt(this.paperId);
      })
      .finally(() => {
        this.getCandidateList();
      });
  }

  genHeaderList(headerList: StructParam[], cacheData?: any[]) {
    if (!cacheData) return headerList;
    const newData = [];
    for (let item of headerList) {
      if (!item.extraData) {
        item.extraData = item.name;
      }
      const hasItem = cacheData.find(child => {
        return child.extraData === item.extraData;
      });
      if (hasItem) {
        hasItem.name = item.name;
        newData.push(hasItem);
      } else {
        item.isShow = 0;
        newData.push(item);
      }
    }
    newData.sort((prev, next) => prev.sort - next.sort);
    return newData;
  }

  // 表头修改为 拖拽排序，原有的选择modal先隐藏 2021-05-11
  showTableSetting() {
    // this.modalTitle.hasDesc = false;
    // this.modalTitle.title = "候选人列表表头设置";
    // this.tableHeaderChange = false;
    // this.showSetting = true;

    // 神策埋点
    track("click_set_list_head", {
      click_from: "从AI面试列表进入候选人列表页"
    });

    this.showSortSetting = true;
    // const odiv = document.getElementById("setting-modal");
    const odiv = document.querySelector(
      ".el-table__fixed-header-wrapper #setting-modal"
    ); // eltable固定列有两个表头原本的查询只会查到第一个表头
    if (odiv) {
      const absoluteLeft = odiv.getBoundingClientRect().left;
      const absoluteTop = odiv.getBoundingClientRect().top;

      // show-setting-modal
      const showPosition = document.getElementById("show-setting-modal");
      if (showPosition) {
        showPosition.style.left = absoluteLeft + 24 - 240 + "px";
        showPosition.style.top = absoluteTop + 29 + "px";
        showPosition.style.position = "absolute";
      }
    }
  }

  getTagList() {
    this.companyIdParam.companyId = Auth.companyId;
    ExamList.companyTags(this.companyIdParam).then(res => {
      if (res.code === 0) {
        this.tagList = res.data.tag;
      }
    });
  }

  handleHeaderChange() {
    this.tempHeaderList = this.headerList.filter(item => {
      return Boolean(item.isShow) === true;
    });
  }

  handleSettingClose() {
    this.showSetting = false;
  }

  handleNoticeClose() {
    this.showNotice = false;
  }

  downloadClose() {
    this.isShowDownloadModal = false;
  }

  sortList(sort: string) {
    console.log("sortList: ", sort);
    switch (sort) {
      case "create-default":
        this.candidateListForm.sortKey = "";
        this.candidateListForm.sortDict = "";
        break;
      case "create-desc":
        this.candidateListForm.sortKey = "created_time";
        this.candidateListForm.sortDict = "desc";
        break;
      case "create-asc":
        this.candidateListForm.sortKey = "created_time";
        this.candidateListForm.sortDict = "asc";
        break;
      case "score-default":
        this.candidateListForm.sortKey = "";
        this.candidateListForm.sortDict = "";
        break;
      case "score-desc":
        this.candidateListForm.sortKey = "score_all";
        this.candidateListForm.sortDict = "desc";
        break;
      case "score-asc":
        this.candidateListForm.sortKey = "score_all";
        this.candidateListForm.sortDict = "asc";
        break;
      case "score-ai-default":
        this.candidateListForm.sortKey = "";
        this.candidateListForm.sortDict = "";
        break;
      case "score-ai-desc":
        this.candidateListForm.sortKey = "score_ai";
        this.candidateListForm.sortDict = "desc";
        break;
      case "score-ai-asc":
        this.candidateListForm.sortKey = "score_ai";
        this.candidateListForm.sortDict = "asc";
        break;
      default:
        break;
    }
    this.getCandidateList();
  }
  //新版发送面试邀请通知
  showSendAskDialog = false;
  isSending = false;
  sendAskSubmit() {
    if (this.candidateGetForm.sendMessage) {
      this.candidateGetForm.sendMessageType = this.candidateGetForm
        .sendMessageTime
        ? 2
        : 0;
    } else {
      this.candidateGetForm.sendMessageType = 1;
      this.candidateGetForm.sendMessageTime = "";
    }
    if (this.isSending) {
      return;
    }
    this.isSending = true;
    Candidate.sendAsk(this.candidateGetForm)
      .then(resp => {
        setTimeout(() => {
          this.isSending = false;
        }, 1000);
        if (resp.code === 0) {
          this.$message.success("通知成功");
          this.showSendAskDialog = false;
          this.getCandidateList();
        } else {
          this.$message.error(resp.message);
        }
      })
      .catch(err => {
        setTimeout(() => {
          this.isSending = false;
        }, 1000);
      });
  }
  //新版发送面试结果通知
  showSendResDialog = false;
  sendResSubmit() {
    Candidate.sendRes(this.candidateGetForm).then(resp => {
      if (resp.code === 0) {
        this.$message.success("通知成功");
        this.showSendResDialog = false;
        // this.getCandidateList();
      } else {
        this.$message.error(resp.message);
      }
    });
  }

  sendResult = false;

  moreOperation(action: string, row: any) {
    this.noticeCandidateStatus = row.submitStatus;
    this.selectedIdList = [row.candidateId];
    this.candidateGetForm.sendMessageTime = "";
    this.candidateGetForm.sendMessage = 1;
    this.candidateGetForm.sendMessageType = 0;
    this.isAllowNotice = row.messageStatus;
    const canSend =
      row.submitStatus === 0 ||
      (row.submitStatus === 3 && row.messageStatus > 0);
    this.hasLoginCandidate = !canSend && row.messageStatus > 0;
    if (this.selectedIdList.length === 0 && this.candidateIdsLength === 0) {
      this.$message.error("请选择待评估的候选人");
      return;
    }
    if (
      action === "single-del-1" ||
      action === "single-del-2" ||
      action === "single-del-answered"
    ) {
      this.delSensorsTrack("del-click", row.submitStatus, row.candidateId);
    }
    switch (action) {
      case "single-tag":
        this.showAddTag = true;
        break;
      case "single-edit":
        // 获取候选人信息
        this.candidateGetForm.candidateId = row.candidateId;
        this.candidateGetForm.companyId = row.companyId;
        Candidate.getCandidateInfo(this.candidateGetForm)
          .then(resp => {
            this.updateCandidateForm.candidateId = row.candidateId;
            this.updateCandidateForm.companyId = row.companyId;
            this.updateCandidateForm.paramList = resp.data.paramList;
          })
          .then(() => {
            this.isShowEdit = true;
          });
        break;
      case "single-notice":
        this.sendResult = false;
        if (!this.V.isNewAi) {
          //老版邀请通知
          this.noticeCandidateId = row.candidateId;
          if (row.submitStatus === 1) {
            //答题中，无法给正在答题中的候选人发送通知
            this.$message.error("无法给正在答题中的候选人发送通知");
          } else {
            this.modalTitle.title = "发送面试通知";
            this.modalTitle.hasDesc = false;
            this.showNotice = true;
          }
        } else {
          //aibuilder版 邀请通知
          this.candidateGetForm.candidateId = row.candidateId;
          this.showSendAskDialog = true;
        }
        break;
      case "single-result-notice":
        //结果通知
        this.candidateGetForm.candidateId = row.candidateId;
        this.sendResult = true;
        this.showSendResDialog = true;
        break;
      case "single-repeat":
        this.repeatCreateFlag = 1;
        this.noticeCandidateId = row.candidateId;
        this.modalTitle.title = "邀请重面";
        this.modalTitle.hasDesc = false;
        this.showRepeatInterview = true;
        break;
      case "single-bgcheck":
        // this.bgCheckStatus.financialRiskStatus = row.bgCheckResult.financialRiskStatus
        // this.bgCheckStatus.identityInfoStatus = row.bgCheckResult.identityInfoStatus
        // this.bgCheckStatus.socialInfoStatus = row.bgCheckResult.socialInfoStatus
        // this.bgCheckMessageStatus = row.bgCheckMessageStatus //背调通知状态
        // this.noticeCandidateId = row.candidateId;
        // this.showBgCheck = true;
        this.bgCheckStatus.financialRiskStatus =
          row.bgCheckResult.financialRiskStatus;
        this.bgCheckStatus.identityInfoStatus =
          row.bgCheckResult.identityInfoStatus;
        this.bgCheckStatus.socialInfoStatus =
          row.bgCheckResult.socialInfoStatus;
        this.checkStatus = row.bgCheckResult.status;
        this.bgCheckMessageStatus = row.bgCheckMessageStatus; //背调通知状态
        this.noticeCandidateId = row.candidateId;
        this.showBgCheck = true;
        break;
      case "single-del-1":
        // 删除提示文案区分，
        this.noticeCandidateId = row.candidateId;
        this.modalTitle.title = "删除候选人";
        this.delDesc =
          "删除后将返还该候选人的面试费用至账户余额，确认删除该候选人吗？";
        this.modalTitle.hasDesc = false;
        this.showCandidateDel = true;
        break;
      case "single-del-2":
        // 删除提示文案区分，
        this.noticeCandidateId = row.candidateId;
        this.modalTitle.title = "删除候选人";
        this.delDesc =
          "尚未支付该候选人的面试费用，删除后不会退款，确认删除该候选人吗？";
        this.modalTitle.hasDesc = false;
        this.showCandidateDel = true;
        break;
      case "single-del-answered":
        // 删除已完成面试记录的文案
        // 删除提示文案区分，
        this.noticeCandidateId = row.candidateId;
        this.modalTitle.title = "删除候选人";
        this.delDesc = "此操作将永久删除这次面试记录，确定要继续删除吗？";
        this.modalTitle.hasDesc = false;
        this.showCandidateDel = true;
        break;
    }
  }

  singleBgCheck(row: any) {
    this.bgCheckStatus.financialRiskStatus =
      row.bgCheckResult.financialRiskStatus;
    this.bgCheckStatus.identityInfoStatus =
      row.bgCheckResult.identityInfoStatus;
    this.bgCheckStatus.socialInfoStatus = row.bgCheckResult.socialInfoStatus;
    this.checkStatus = row.bgCheckResult.status;
    this.bgCheckMessageStatus = row.bgCheckMessageStatus; //背调通知状态
    this.noticeCandidateId = row.candidateId;
    this.showBgCheck = true;
  }

  repeatInterviewCancel() {
    this.showRepeatInterview = false;
  }

  repeatLock = false;

  repeatInterviewSubmit() {
    if (this.repeatCreateFlag === 2) {
      //多选邀请重面
      this.showMRepeatInterviewFunc();
    } else {
      //单个邀请重面
      if (this.repeatLock) {
        return;
      }
      this.repeatLock = true;
      this.candidateRepeatCreateForm.examId = parseInt(this.paperId);
      this.candidateRepeatCreateForm.companyId = parseInt(Auth.companyId);
      this.candidateRepeatCreateForm.sendMessage = 1;
      this.candidateRepeatCreateForm.candidateId = this.noticeCandidateId;
      Candidate.candidateRepeatCreate(this.candidateRepeatCreateForm)
        .then(resp => {
          setTimeout(() => {
            this.repeatLock = false;
          }, 1000);
          // if (resp.code === 0 && resp.data[0].isOk) {
          if (resp.code === 0) {
            this.$message.success("邀请成功");
            this.getCandidateList();
          } else {
            this.$message.error(resp.message);
          }
        })
        .finally(() => {
          this.showRepeatInterview = false;
        });
    }
  }

  showMRepeatInterview() {
    if (!this.$P.person.reInvite) return;
    this.repeatCreateFlag = 2;
    this.modalTitle.title = "邀请重面";
    this.modalTitle.hasDesc = false;
    this.showRepeatInterview = true;
  }

  showMRepeatInterviewFunc() {
    this.candidateRepeatMCreateForm.sendMessage = 1;
    this.candidateRepeatMCreateForm.examId = parseInt(this.paperId);
    this.candidateRepeatMCreateForm.companyId = parseInt(Auth.companyId);
    //  通知列表
    if (this.repeatLock) {
      return;
    }
    if (this.selectedList.length === 0 && this.selectedIdList.length === 0) {
      //没有全选和点击复选框选择数据
      this.$message.error("请选择需要邀请重面的候选人");
      return;
    } else {
      if (this.selectedList.length > 0) {
        const filterIdList: number[] = [];
        this.selectedList.forEach((item: any, key: number) => {
          filterIdList.push(parseInt(item.candidateId));
        });
        this.candidateRepeatMCreateForm.candidateIdList = filterIdList;
      } else {
        this.candidateRepeatMCreateForm.candidateIdList = this.selectedIdList;
      }
    }
    this.repeatLock = true;
    Candidate.candidateMRepeatCreate(this.candidateRepeatMCreateForm)
      .then(resp => {
        setTimeout(() => {
          this.repeatLock = false;
        }, 1000);
        if (resp.code === 0) {
          this.$message.success("提交成功");
          // let finishedAll = false; //默认添加的所有人里面包含没有完成答题的候选人
          // resp.data.forEach((repeatRes: any) => {
          //   if (repeatRes.isOk) {
          //     finishedAll = true;
          //   }
          // });
          // if (finishedAll) {
          //   this.$message.success("邀请成功");
          //   this.getCandidateList();
          // } else {
          //   this.$message.error("所选候选人尚未完成面试，完成后才可邀请重面");
          // }
        } else {
          this.$message.error(resp.message);
        }
      })
      .finally(() => {
        this.showRepeatInterview = false;
      });
  }

  mNoticeCancel() {
    this.showMSendMessage = false;
    this.candidateIdsLength = 0;
  }

  errorCandidateList: number[] = [];
  selectAllCandidateList: any = [];

  mNoticeRemove() {
    const multipleTable = this.$refs.multipleTable;
    if (multipleTable) {
      this.errorCandidateList.forEach(item => {
        const row = this.selectedList.find(
          (row: any) => row.candidateId === item
        );
        multipleTable.toggleRowSelection(row, false);
      });
      if (!this.selectedAllFlag) {
        this.selectedList = this.selectedList.filter((row: any) => {
          return !this.errorCandidateList.includes(row.candidateId);
        });
      } else {
        console.log(this.errorCandidateList);
        this.selectAllCandidateList = this.selectAllCandidateList.filter(
          (row: any) => {
            return !this.errorCandidateList.includes(row.id);
          }
        );
        this.candidateIdsLength = this.selectAllCandidateList.length;
        console.log(this.selectAllCandidateList);
        // this.selectedAllFlag = false;
      }
      this.errorCandidateList = [];
      this.showMSendMessage = false;
    }
  }

  isMSending = false;
  //群发通知
  mNoticeSubmit() {
    if (this.isMSending) {
      return;
    }
    const filterIdList: number[] = [];
    this.selectedList.forEach((item: any, key: number) => {
      filterIdList.push(parseInt(item.candidateId));
    });
    if (filterIdList.length <= 0 && this.selectAllCandidateList.length <= 0) {
      this.$message.error("未选择需要通知的候选人");
    } else {
      console.log(this.selectedAllFlag);
      if (this.selectedAllFlag) {
        this.mDeleteParam.candidateIdList = this.selectAllCandidateList.map(
          item => item.id
        );
      } else {
        this.mDeleteParam.candidateIdList = filterIdList;
      }
      this.mDeleteParam.companyId = parseInt(Auth.companyId);

      if (!this.V.isNewAi) {
        // 旧版批量
        if (this.mDeleteParam.sendMessage) {
          this.mDeleteParam.sendMessageType = this.mDeleteParam.sendMessageTime
            ? 2
            : 0;
        } else {
          this.mDeleteParam.sendMessageType = 1;
          this.mDeleteParam.sendMessageTime = "";
        }
        this.isMSending = true;
        Candidate.mSendMessage(this.mDeleteParam)
          .then(resp => {
            if (resp.code === 0) {
              this.$message.success("通知成功");
              this.showMSendMessage = false;
              this.getCandidateList();
            } else {
              this.$message.error(resp.message);
            }
            setTimeout(() => {
              this.isMSending = false;
            }, 1000);
          })
          .finally(() => {
            setTimeout(() => {
              this.isMSending = false;
            }, 1000);
            this.candidateIdsLength = 0;
          });
      } else {
        //新版批量
        const env = this.modalTitle.title.includes("面试邀请通知") ? 1 : 10;
        if (this.mDeleteParam.sendMessage) {
          this.mDeleteParam.sendMessageType = this.mDeleteParam.sendMessageTime
            ? 2
            : 0;
        } else {
          this.mDeleteParam.sendMessageType = 1;
          this.mDeleteParam.sendMessageTime = "";
        }
        if (this.isMSending) {
          return;
        }
        this.isMSending = true;
        Candidate.mSendAsk(this.mDeleteParam, env)
          .then(resp => {
            if (resp.code === 0) {
              this.$message.success("保存成功");
              this.getCandidateList();
            } else {
              this.$message.error(resp.message);
            }
            setTimeout(() => {
              this.isMSending = false;
            }, 1000);
          })
          .then(() => {
            this.showMSendMessage = false;
          })
          .finally(() => {
            setTimeout(() => {
              this.isMSending = false;
            }, 1000);
            this.candidateIdsLength = 0;
          });
      }
    }
  }
  noticeCancel() {
    this.showNotice = false;
  }

  noticeSubmit() {
    this.candidateGetForm.candidateId = this.noticeCandidateId;
    this.candidateGetForm.companyId = parseInt(Auth.companyId);
    if (this.candidateGetForm.candidateId > 0) {
      Candidate.noticeCandidate(this.candidateGetForm).then(resp => {
        if (resp.code === 0) {
          this.$message.success("通知成功");
          this.showNotice = false;
          this.getCandidateList();
        } else {
          this.$message.error(resp.message);
        }
      });
    } else {
      this.$message.error("请选择需要通知的候选人");
    }
  }

  delCancel() {
    this.showCandidateDel = false;
  }

  delSubmit() {
    this.delSensorsTrack(
      "del-confirm-click",
      this.noticeCandidateStatus,
      this.noticeCandidateId
    );
    this.candidateGetForm.candidateId = this.noticeCandidateId;
    this.candidateGetForm.companyId = parseInt(Auth.companyId);
    if (this.candidateGetForm.candidateId > 0 || this.candidateIdsLength > 0) {
      // this.tableLoading = true;
      Candidate.delCandidate(this.candidateGetForm)
        .then(resp => {
          if (resp.code === 0) {
            this.$message.success("删除成功");
            if (this.currentListLength === 1) {
              if (this.candidateListForm.page > 1) {
                --this.candidateListForm.page;
              } else {
                this.candidateListForm.page = 1;
              }
            }
            this.getCandidateList();
          } else {
            this.$message.error(resp.message);
          }
        })
        .then(() => {
          this.showCandidateDel = false;
          // this.tableLoading = false;
        });
    } else {
      this.$message.error("请选择需要删除的候选人");
    }
  }

  async callbackRequest() {
    let candidateIdList = [];
    if (this.selectedList.length > 0) {
      const filterIdList: number[] = [];
      this.selectedList.forEach((item: any, key: number) => {
        if (
          typeof this.scoreAiConvert(
            item.submitStatus,
            item.scoreAi,
            item.aiProcessStatus
          ) === "number" &&
          item.outLinkStatus == 1
        ) {
          // ai出分且三方对接数据可以触发
          filterIdList.push(parseInt(item.candidateId));
        }
      });
      candidateIdList = filterIdList;
    } else {
      candidateIdList = this.selectedIdList;
      this.candidateRepeatMCreateForm.candidateIdList = this.selectedIdList;
    }
    console.log(candidateIdList);
    if (candidateIdList.length > 0) {
      await request.post("/aiExam/candidate/mCallback", {
        companyId: Auth.companyId,
        candidateIdList: candidateIdList
      });
    }
    this.showMarkCallback = false;
    this.getCandidateList();
  }

  mDelCancel() {
    this.showMDelete = false;
    this.candidateIdsLength = 0;
  }

  mDelSubmit() {
    const filterIdList: number[] = [];
    this.selectedList.forEach((item: any, key: number) => {
      filterIdList.push(parseInt(item.candidateId));
    });
    if (filterIdList.length <= 0 && this.candidateIdsLength === 0) {
      this.$message.error("未选择待删除的数据");
    } else {
      if (this.candidateIdsLength === 0) {
        this.mDeleteParam.candidateIdList = filterIdList;
      } else {
        this.mDeleteParam.candidateIdList = this.candidateListForm.candidateIdList;
      }
      this.mDeleteParam.companyId = parseInt(Auth.companyId);
      Candidate.mDelete(this.mDeleteParam)
        .then(resp => {
          if (resp.code === 0) {
            if (resp.data.length === 1 && resp.data[0].isOk === false) {
              this.$message.error(resp.data[0].error);
            } else {
              this.$message.success("删除成功");
            }
          } else {
            this.$message.error(resp.message);
          }
        })
        .then(() => {
          if (this.currentListLength === 1) {
            if (this.candidateListForm.page > 1) {
              --this.candidateListForm.page;
            } else {
              this.candidateListForm.page = 1;
            }
          }
          this.getCandidateList();
          this.showMDelete = false;
        })
        .finally(() => {
          this.candidateIdsLength = 0;
        });
    }
  }

  handleCandidateDelClose() {
    this.showCandidateDel = false;
    this.candidateIdsLength = 0;
  }

  handleMDeleteClose() {
    this.showMDelete = false;
    this.candidateIdsLength = 0;
  }

  showAddTags() {
    if (this.candidateIdsLength === 0) {
      const filterIdList: number[] = [];
      this.selectedList.forEach((item: any, key: number) => {
        filterIdList.push(parseInt(item.candidateId));
      });
      this.selectedIdList = filterIdList;
      if (this.selectedIdList.length === 0 && this.candidateIdsLength === 0) {
        this.$message.error("请选择需要添加标签的候选人");
      } else {
        this.showAddTag = true;
      }
    } else {
      this.showAddTag = true;
    }
  }

  addTagSuccess() {
    this.candidateIdsLength = 0;
    this.getCandidateList();
    this.showAddTag = false;
  }

  addTagCancel() {
    this.candidateIdsLength = 0;
    this.getCandidateList();
    this.showAddTag = false;
  }

  handleSelectionChange(e: any) {
    this.selectAllFlag = false;
    this.selectedAllFlag = false;
    this.candidateIdsLength = 0;
    this.selectAllCandidateList = [];
    console.log("haskdhsak");
    this.selectedList = e;
  }

  candidateBuy(row: any) {
    this.candidateGetForm.candidateId = row.candidateId;
    this.candidateGetForm.companyId = row.companyId;
    Candidate.candidateBuy(this.candidateGetForm)
      .then(resp => {
        if (resp.code === 0) {
          this.$message.success("购买成功");
        } else {
          this.$message.error("购买失败");
        }
      })
      .then(() => {
        this.getCandidateList();
      });
  }

  selectAllFlag = false;

  selectAllList(commandStr: string) {
    if (commandStr === "select-all") {
      this.isAllowNotice = 1;
      this.hasLoginCandidate = false;
      this.showSecondAskDialog = true;
      this.dialogSendConcent = `选择全部${this.total}个候选人`;
    }
  }
  selectAllSure() {
    this.$refs.multipleTable.clearSelection();
    this.selectedAllFlag = true;
    Array.prototype.push.apply(
      this.$refs.multipleTable.selection,
      this.candidateList
    );
    this.candidateList.push();
    this.selectedList = [];
    this.candidateListForm.page = 1;
    this.tableLoading = true;
    ExamList.getCandidateListIds(this.candidateListForm)
      .then(res => {
        console.log("selected All List: ", res.data);
        this.total = res.data.count;

        this.auditArr.await =
          res.data.numbers.submitStatusFinishAuditStatusNoAudit;
        this.auditArr.passed =
          res.data.numbers.submitStatusFinishAuditStatusPass;
        this.auditArr.pending =
          res.data.numbers.submitStatusFinishAuditStatusWait;
        this.auditArr.refused =
          res.data.numbers.submitStatusFinishAuditStatusRefuse;
        this.auditArr.unfinish =
          res.data.numbers.submitStatusNotSignIn +
          res.data.numbers.submitStatusSignIn +
          res.data.numbers.submitStatusAnswering;
        this.selectAllFlag = true;
        this.selectAllCandidateList = res.data.candidateList;

        this.candidateListForm.candidateIdList = res.data.candidateIds;
        this.selectedIdList = res.data.candidateIds;
        this.candidateIdsLength = res.data.candidateIds.length;
      })
      .finally(() => {
        this.tableLoading = false;
        this.showSecondAskDialog = false;
      });
  }

  // 预加载导出表头数据
  async preloadExportHeaders(candidateIdList?: number[]) {
    const exportModule = await import("@/api/export");

    const params = this.buildExportParams(candidateIdList);
    params.execType = 1; // 获取表头

    return await exportModule.ExportApi.newTaskCand(params);
  }

  // 预加载答题明细表头数据
  async preloadAnswerHeaders(candidateIdList?: number[]) {
    const exportModule = await import("@/api/export");

    const params = this.buildAnswerExportParams(candidateIdList);
    params.execType = 1; // 获取表头

    return await exportModule.ExportApi.newTaskCandAns(params);
  }

  // 构建答题明细导出参数
  buildAnswerExportParams(candidateIdList?: number[]) {
    const params: any = {
      examType: "aibuilder",
      examId: this.candidateListForm.examId,
      examVersionId: this.candidateListForm.examVersionId,
      subExamId: this.candidateListForm.subExamId,
      candidateIdList:
        candidateIdList !== undefined
          ? candidateIdList
          : this.getCandidateIds(),

      // 从筛选表单获取其他参数
      searchKeyLike: this.candidateListForm.searchKeyLike,
      showNameOrPhone: this.candidateListForm.showNameOrPhone,
      phone: this.candidateListForm.phone,
      positionId: this.candidateListForm.positionId,
      tagNameList: this.candidateListForm.tagNameList,
      aiRecommendStatusList: this.candidateListForm.aiRecommendStatusList,
      submitStatusList: this.candidateListForm.submitStatusList,
      auditStatusList: this.candidateListForm.auditStatusList,
      createdTime:
        this.candidateListForm.createdTime &&
        this.candidateListForm.createdTime.length === 2
          ? [
              this.candidateListForm.createdTime[0],
              this.candidateListForm.createdTime[1]
            ]
          : undefined,
      beginTime:
        this.candidateListForm.beginTime &&
        this.candidateListForm.beginTime.length === 2
          ? [
              this.candidateListForm.beginTime[0],
              this.candidateListForm.beginTime[1]
            ]
          : undefined,
      submitTime:
        this.candidateListForm.submitTime &&
        this.candidateListForm.submitTime.length === 2
          ? [
              this.candidateListForm.submitTime[0],
              this.candidateListForm.submitTime[1]
            ]
          : undefined,

      // 答题明细特有的参数
      questionTypeList: [6], // 默认视频题
      maxAskAppendRound: 3 // 默认3轮追问
    };

    return params;
  }

  // 构建导出参数
  buildExportParams(candidateIdList?: number[]) {
    const params: any = {
      examType: "aibuilder",
      examId: this.candidateListForm.examId,
      examVersionId: this.candidateListForm.examVersionId,
      subExamId: this.candidateListForm.subExamId,
      candidateIdList:
        candidateIdList !== undefined
          ? candidateIdList
          : this.getCandidateIds(),

      // 从筛选表单获取其他参数
      searchKeyLike: this.candidateListForm.searchKeyLike,
      showNameOrPhone: this.candidateListForm.showNameOrPhone,
      phone: this.candidateListForm.phone,
      positionId: this.candidateListForm.positionId,
      tagNameList: this.candidateListForm.tagNameList,
      aiRecommendStatusList: this.candidateListForm.aiRecommendStatusList,
      submitStatusList: this.candidateListForm.submitStatusList,
      auditStatusList: this.candidateListForm.auditStatusList,
      createdTime:
        this.candidateListForm.createdTime &&
        this.candidateListForm.createdTime.length === 2
          ? [
              this.candidateListForm.createdTime[0],
              this.candidateListForm.createdTime[1]
            ]
          : undefined,
      beginTime:
        this.candidateListForm.beginTime &&
        this.candidateListForm.beginTime.length === 2
          ? [
              this.candidateListForm.beginTime[0],
              this.candidateListForm.beginTime[1]
            ]
          : undefined,
      submitTime:
        this.candidateListForm.submitTime &&
        this.candidateListForm.submitTime.length === 2
          ? [
              this.candidateListForm.submitTime[0],
              this.candidateListForm.submitTime[1]
            ]
          : undefined,
      paramSearchList: this.candidateListForm.paramSearchList,
      afterBuy: this.candidateListForm.afterBuy,
      outLinkStatusList: this.candidateListForm.outLinkStatusList,
      markCallbackStatusList: this.candidateListForm.markCallbackStatusList
    };

    return params;
  }

  // 获取候选人ID列表
  getCandidateIds() {
    if (this.candidateIdsLength > 0) {
      return this.candidateListForm.candidateIdList || [];
    }

    if (this.selectedList.length > 0) {
      return this.selectedList.map((item: any) => parseInt(item.candidateId));
    }

    return [];
  }

  // 处理全部导出命令
  async handleExportAllCommand(command: string) {
    try {
      // 设置为全部导出模式
      this.exportMode = "all";

      if (command === "comprehensive") {
        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: "正在获取导出字段...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        try {
          const headerResponse = await this.preloadExportHeaders([]);
          if (headerResponse) {
            this.preloadedHeaders = headerResponse.headers || [];
            this.showExportDrawer = true;
          }
        } catch (error) {
          console.error("预加载表头失败:", error);
          this.$message.error("获取导出字段失败，请稍后重试");
        } finally {
          loading.close();
        }
      } else if (command === "answer") {
        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: "正在获取导出字段...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        try {
          const headerResponse = await this.preloadAnswerHeaders([]);
          if (headerResponse) {
            this.preloadedAnswerHeaders = headerResponse.headers || [];
            this.showVideoDrawer = true;
          }
        } catch (error) {
          console.error("预加载表头失败:", error);
          this.$message.error("获取导出字段失败，请稍后重试");
        } finally {
          loading.close();
        }
      }
    } catch (error) {
      console.error("预加载表头失败:", error);
      this.$message.error("获取导出字段失败，请稍后重试");
    }
  }

  async exportData(command: string) {
    if (this.selectedList.length <= 0 && this.candidateIdsLength === 0) {
      this.$message.error("请选择要导出的候选人");
      return;
    }

    // 设置为选中导出模式
    this.exportMode = "selected";

    if (command === "exportData") {
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: "正在获取导出字段...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      try {
        // 预加载表头数据，如果成功再打开抽屉
        const headerResponse = await this.preloadExportHeaders();

        // 确保获取到有效的headers数组
        let headers = headerResponse.headers || [];
        if (!Array.isArray(headers)) {
          // 如果headers不是数组，设置为空数组
          headers = [];
        }

        this.preloadedHeaders = headers;
        this.showExportDrawer = true;
      } catch (error) {
        this.$message.error("获取导出字段失败，请稍后重试");
      } finally {
        loading.close();
      }
    } else if (command === "exportVideoQuestion") {
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: "正在获取导出字段...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      try {
        // 预加载表头数据，如果成功再打开抽屉
        const headerResponse = await this.preloadAnswerHeaders();

        // 确保获取到有效的headers数组
        let headers = headerResponse.headers || [];
        if (!Array.isArray(headers)) {
          // 如果headers不是数组，设置为空数组
          headers = [];
        }

        this.preloadedAnswerHeaders = headers;
        this.showVideoDrawer = true;
      } catch (error) {
        this.$message.error("获取导出字段失败，请稍后重试");
      } finally {
        loading.close();
      }
    }
  }

  exportCandidate() {
    if (this.selectedList.length <= 0 && this.candidateIdsLength === 0) {
      this.$message.error("请选择要导出的候选人");
      return;
    }
    if (this.candidateIdsLength === 0) {
      const candidateIdList = new Array<number>();
      this.selectedList.forEach((list: any) => {
        candidateIdList.push(parseInt(list.candidateId));
      });
      this.candidateListForm.candidateIdList = candidateIdList;
    }
    this.candidateListForm.isFsk = this.isYD ? 1 : 0;

    const exportForm = this.candidateListForm;
    if (this.candidateListForm.auditStatusList.length === 3) {
      exportForm.auditStatusList = [];
    }
    this.loadingList = true;
    ExamList.candidateListExport(this.candidateListForm)
      .then(res => {
        if (res.code === 0) {
          if (res.data.isAsync === 1) {
            this.loadingList = false;
            this.isShowDownloadModal = true;
          } else {
            this.loadingList = false;
            const dataUrl = res.data.ossUrl;
            const a = document.createElement("a");
            a.href = dataUrl;
            a.setAttribute("download", "候选人列表");
            a.click();
          }
        }
      })
      .catch(() => {
        this.loadingList = false;
      })
      .finally(() => {
        this.candidateIdsLength = 0;
        this.candidateListForm.candidateIdList = [];
      });
  }

  // 处理答题明细导出确认
  async handleAnswerExportConfirm(exportParams: any) {
    try {
      const loading = this.$loading({
        lock: true,
        text: "正在创建导出任务...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      // 根据导出模式构建candidateIdList参数
      const candidateIdList = this.exportMode === "all" ? [] : undefined;

      // 构建完整的导出参数
      const params = {
        ...this.buildAnswerExportParams(candidateIdList),
        execType: 0, // 发起导出任务
        taskName: exportParams.fileName,
        suffix: exportParams.suffix,
        headersInSql: exportParams.headersInSql,
        questionTypeList: exportParams.questionType,
        maxAskAppendRound: exportParams.maxAskAppendRound
      };

      const exportModule = await import("@/api/export");
      const result = await exportModule.ExportApi.newTaskCandAns(params);

      loading.close();

      if (result.exportId) {
        this.$confirm("导出任务创建成功", "提示", {
          confirmButtonText: "查看",
          cancelButtonText: "取消",
          type: "success"
        })
          .then(() => {
            this.$router.push(`/export/list?companyId=${Auth.companyId}`);
          })
          .catch(() => {
            //
          });
        this.showVideoDrawer = false;
      } else {
        this.$message.error("导出任务创建失败");
      }
    } catch (error) {
      this.$message.error("导出失败，请稍后重试");
    }
  }

  exportVideoQuestion() {
    if (this.selectedList.length <= 0 && this.candidateIdsLength === 0) {
      this.$message.error("请选择要导出的候选人");
      return;
    }
    if (this.candidateIdsLength === 0) {
      const candidateIdList = new Array<number>();
      this.selectedList.forEach((list: any) => {
        candidateIdList.push(parseInt(list.candidateId));
      });
      this.candidateListForm.candidateIdList = candidateIdList;
    }
    this.candidateListForm.isFsk = this.isYD ? 1 : 0;

    const exportForm = this.candidateListForm;
    if (this.candidateListForm.auditStatusList.length === 3) {
      exportForm.auditStatusList = [];
    }
    this.loadingList = true;
    ExamList.candidateVideoListExport(this.candidateListForm)
      .then(res => {
        if (res.code === 0) {
          if (res.data.isAsync === 1) {
            this.loadingList = false;
            this.isShowDownloadModal = true;
          } else {
            this.loadingList = false;
            const dataUrl = res.data.ossUrl;
            const a = document.createElement("a");
            a.href = dataUrl;
            a.setAttribute("download", "候选人列表");
            a.click();
          }
        }
      })
      .catch(() => {
        this.loadingList = false;
      })
      .finally(() => {
        this.candidateIdsLength = 0;
        this.candidateListForm.candidateIdList = [];
      });
  }

  async exportAllCandidate() {
    // 预加载表头数据
    // await this.preloadExportHeaders();
    // // 显示导出抽屉
    // this.showExportDrawer = true;
  }

  candidateMDelete() {
    this.modalTitle.title = "删除候选人";
    this.modalTitle.hasDesc = false;
    this.showMDelete = true;
  }

  getYmd(timeStr: string) {
    return timeStr.substring(0, 10);
  }

  getHis(timeStr: string) {
    return timeStr.substring(11, 20);
  }

  // candidateMSendMessage() {
  //   let selectedSendList = [];
  //   selectedSendList = this.selectedList.filter((res: any) => {
  //     return parseInt(res.messageStatus) > 0;
  //   });
  //   if (this.selectedAllFlag) {
  //     this.modalTitle.title = "确认通知";
  //     this.modalTitle.hasDesc = false;
  //     this.showMSendMessage = true;
  //   } else if (selectedSendList.length === 0) {
  //     this.$message.error("无法给公开作答的候选人发送通知");
  //   } else {
  //     this.modalTitle.title = "确认通知";
  //     this.modalTitle.hasDesc = false;
  //     this.showMSendMessage = true;
  //   }
  // }

  //群发邀请
  candidateMSendMessage() {
    this.sendResult = false;
    this.errorCandidateList = [];
    if (!this.selectAllFlag) {
      let selectedSendList = [];
      selectedSendList = this.selectedList.filter((res: any) => {
        if (parseInt(res.messageStatus) === 0) {
          this.errorCandidateList.push(res.candidateId);
        }
        return parseInt(res.messageStatus) > 0;
      });
      this.hasLoginCandidate = false;
      this.isAllowNotice = 1;
      if (this.setTimeSendMessage) {
        let flag = false;
        this.selectedList.forEach((item: any) => {
          // 未登记的和非公开邀请的已登记的候选人
          const canSend =
            item.submitStatus === 0 ||
            (item.submitStatus === 3 && item.messageStatus > 0);
          if (!canSend && item.messageStatus > 0) {
            flag = true;
            if (!this.errorCandidateList.includes(item.candidateId)) {
              this.errorCandidateList.push(item.candidateId);
            }
          }
        });
        if (flag) {
          this.hasLoginCandidate = true;
        }
      }
      console.log(this.errorCandidateList);
      if (selectedSendList.length < this.selectedList.length) {
        this.isAllowNotice = 0;
      }
    } else {
      this.hasLoginCandidate = false;
      this.isAllowNotice = 1;
      console.log(this.selectAllCandidateList);
      this.selectAllCandidateList.forEach((item: any) => {
        const canSend =
          item.submitStatus === 0 ||
          (item.submitStatus === 3 && item.messageStatus > 0);
        let flag = false;
        if (parseInt(item.messageStatus) === 0) {
          this.isAllowNotice = 0;
          flag = true;
        }
        if (!canSend && item.messageStatus > 0) {
          this.hasLoginCandidate = true;
          flag = true;
        }
        if (flag) {
          this.errorCandidateList.push(item.id);
        }
      });
    }
    // if (this.candidateIdsLength > 100 || this.selectedList.length > 100) {
    //   this.$alert("一次最多邀请100个", "提示", {
    //     confirmButtonText: "确定"
    //   });
    //   return;
    // }
    this.mDeleteParam.sendMessage = 1;
    this.mDeleteParam.sendMessageType = 0;
    this.mDeleteParam.sendMessageTime = "";
    this.sendResult = false;
    if (this.selectedAllFlag) {
      this.modalTitle.title = `面试邀请通知（${
        this.selectedList.length
          ? this.selectedList.length
          : this.selectAllCandidateList.length
      }人）`;
      this.modalTitle.hasDesc = false;
      this.showMSendMessage = true;
    } else {
      this.modalTitle.title = `面试邀请通知（${
        this.selectedList.length
          ? this.selectedList.length
          : this.selectAllCandidateList.length
      }人）`;
      this.modalTitle.hasDesc = false;
      this.showMSendMessage = true;
    }
  }
  getHightlightRow({ row }: any) {
    if (this.errorCandidateList.includes(row.candidateId)) {
      return "hightlight-row";
    }
    return "";
  }
  //群发结果
  candidateMSendMessageE() {
    this.isAllowNotice = 1;
    this.hasLoginCandidate = false;
    this.modalTitle.title = "面试结果通知";
    this.sendResult = true;
    this.modalTitle.hasDesc = false;
    this.showMSendMessage = true;
  }
  //阅卷列表页
  toCandidateEvaluate() {
    //无权限 或 面试状态选的是未交卷
    if (!this.$P.person.judge || this.selectNoSubmit) return;
    ExamList.getCandidateListIds(this.candidateListForm).then(res => {
      this.candidateListForm.candidateIdList = res.data.candidateIds; //新需求：阅卷页以后是打包带走这些筛选出来的人
      if (res?.data?.candidateIds?.length === 0) {
        this.$message.warning("没有可评估的候选人");
        return;
      }
      sessionStorage.setItem(
        "candidateParams",
        JSON.stringify(this.candidateListForm)
      );
      const cid = Auth.companyId;
      const previewUrl = `/exam/mark?examId=${
        this.paperId
      }&companyId=${cid}&auditStatus=${
        // this.isWorker
        //   ? 2
        //   :
        this.candidateListForm.auditStatusList.length === 1
          ? this.candidateListForm.auditStatusList[0]
          : 0
      }`;
      //普工去待定页签   别的去待评估页签
      window.open(previewUrl);
      this.candidateListForm.candidateIdList = [];
    });
  }
  //阅卷指定单人
  async toSingleCandidateEvaluate(row: any) {
    ExamList.getCandidateListIds(this.candidateListForm).then(async res => {
      this.candidateListForm.candidateIdList = res.data.candidateIds;
      sessionStorage.setItem(
        "candidateParams",
        JSON.stringify(this.candidateListForm)
      );
      const cid = Auth.companyId;
      // const isF = row.examType === "test" ? 1 : undefined; //fsk模式
      // const isF = this.V.isWorker ? 1 : undefined; //fsk模式
      let previewUrl = `/exam/mark?examId=${this.paperId}&companyId=${cid}&auditStatus=${row.auditStatus}&connectCode=${row.connectCode}`;
      //获取报告鉴权tid
      await Decrypt.get({
        candidateId: String(row.candidateId)
      }).then(res => {
        previewUrl += "&tid=" + res.tid;
      });
      window.open(previewUrl);
      this.candidateListForm.candidateIdList = [];
    });
  }
  //数据标注
  toSuperMark() {
    const cid = Auth.companyId;
    const previewUrl = `/exam/mark?examId=${this.paperId}&companyId=${cid}&auditStatus=0&isHrMark=1`;
    window.open(previewUrl);
  }

  candidateEvaluate(nums: string, row: any) {
    if (!this.$P.person.judge) return;
    if (nums === "more") {
      if (this.candidateIdsLength === 0) {
        const passedList = this.selectedList.filter((res: any) => {
          return res.auditStatus === 1;
        });
        const awaitList = this.selectedList.filter((res: any) => {
          return res.auditStatus === 0 && res.submitStatus === 2;
        });
        this.auditArr.await = awaitList.length;
        this.auditArr.passed = passedList.length;
        const penddingList = this.selectedList.filter((res: any) => {
          return res.auditStatus === 2;
        });
        this.auditArr.pending = penddingList.length;
        const refusedList = this.selectedList.filter((res: any) => {
          return res.auditStatus === 3;
        });
        this.auditArr.refused = refusedList.length;
        const unfinishList = this.selectedList.filter((res: any) => {
          return res.submitStatus < 2 || res.submitStatus === 3;
        });
        this.auditArr.unfinish = unfinishList.length;
      }
    } else {
      this.selectedList = [row];
    }

    if (this.selectedList.length > 1) {
      this.multiAudit = true;
    } else {
      this.multiAudit = false;
    }
    if (this.candidateIdsLength === 0) {
      const filterIdList: number[] = [];
      this.selectedList.forEach((item: any, key: number) => {
        filterIdList.push(parseInt(item.candidateId));
      });
      this.selectedIdList = filterIdList;
      if (this.selectedIdList.length === 0) {
        this.$message.error("请选择待评估的候选人");
      } else {
        this.showAuditDialog = true;
      }
    } else {
      this.multiAudit = true;
      this.showAuditDialog = true;
    }
  }
  getTagColor(prop: EnumTagColor) {
    return EnumTagColor[prop ?? "tags"] + "40";
  }
  removeTag(row: any, tag: string, extraData: EnumTagMap) {
    this.tableLoading = true;
    this.deleteTagsForm.candidateId = row.candidateId;
    this.deleteTagsForm.companyId = row.companyId;
    this.deleteTagsForm.tags = [tag];
    this.deleteTagsForm.tagType = (EnumTagMap[
      extraData
    ] as unknown) as EnumTagType;
    Candidate.candidateDeleteTags(this.deleteTagsForm)
      .then(res => {
        if (res.code === 0) {
          this.$message.success("删除标签成功");
          this.getCandidateList();
        }
      })
      .finally(() => {
        this.tableLoading = false;
      });
  }
  //报告页
  async candidateReport(row: any) {
    const previewUrl = await this.getReportUrl(row);

    window.open(previewUrl);
  }

  showMore() {
    this.showMoreFilter = !this.showMoreFilter;
    this.showSortSetting = false;
  }

  messageStatusConvert(messageStatus: number) {
    let statusName = "";
    switch (messageStatus) {
      case 0:
        statusName = "公开邀请";
        break;
      case 1:
        statusName = "未通知";
        break;
      case 2:
        statusName = "已通知未打开";
        break;
      case 3:
        statusName = "已通知已打开";
        break;
      default:
        break;
    }
    return statusName;
  }

  auditStatusConvert(
    auditStatus: number,
    submitStatus: number,
    submitStatusForFsk: number,
    auditStatusAi: number,
    auditTime: string,
    auditTimeAi: string,
    costStatus: number,
    aiProcessStatus: number
  ) {
    if (this.isYD && auditTime !== auditTimeAi) {
      // 如果为富士康且有HR参与打分，则显示HR打分的值
      if (auditStatus === 0) {
        return "-";
      } else if (auditStatus === 1) {
        return "通过(HR)";
      } else if (auditStatus === 2) {
        return "待定(HR)";
      } else if (auditStatus === 3) {
        return "拒绝(HR)";
      } else {
        return "-";
      }
    } else {
      if (this.isYD && submitStatusForFsk !== 40) {
        return "-";
      } else {
        if ((submitStatus !== 2 && submitStatus !== 5) || costStatus !== 2) {
          return "-";
        } else {
          // 如果AI打分字段的显示为 正在打分，那么评估结果字段展示 -
          if (submitStatus === 2 && aiProcessStatus !== 3) {
            return "-";
          }

          if (auditStatus === 0) {
            return "待评估";
          } else if (auditStatus === 1) {
            return "通过";
          } else if (auditStatus === 2) {
            return "待定";
          } else if (auditStatus === 3) {
            return "拒绝";
          } else {
            return "待评估";
          }
        }
      }
    }
  }

  aiRecommendColor(aiRecommendStatus: number, costStatus: number) {
    if (aiRecommendStatus === 0 || costStatus !== 2) {
      return "audit-color-default";
    } else if (aiRecommendStatus === 1) {
      return "audit-color-2";
    } else if (aiRecommendStatus === 2) {
      return "audit-color-3";
    } else if (aiRecommendStatus === 3) {
      return "audit-color-4";
    } else {
      return "audit-color-1";
    }
  }

  aiRecommendStatusConvert(aiRecommendStatus: number, costStatus: number) {
    if (costStatus !== 2 || aiRecommendStatus == 0) {
      return "-";
    } else if (aiRecommendStatus == 10) {
      return "不推荐";
    } else if (aiRecommendStatus == 20) {
      return "一般";
    } else if (aiRecommendStatus == 30) {
      return "推荐";
    } else if (aiRecommendStatus == 40) {
      return "非常推荐";
    }
  }

  auditStatusColor(
    auditStatus: number,
    submitStatus: number,
    submitStatusForFsk: number,
    auditStatusAi: number,
    auditTime: string,
    auditTimeAi: string,
    costStatus: number,
    aiProcessStatus: number
  ) {
    if (this.isYD && auditTime !== auditTimeAi) {
      // 如果为富士康且有HR参与打分，则显示HR打分的值
      if (auditStatus === 0) {
        return "new-audit-color-1";
      } else if (auditStatus === 1) {
        return "new-audit-color-2";
      } else if (auditStatus === 2) {
        return "new-audit-color-3";
      } else if (auditStatus === 3) {
        return "new-audit-color-4";
      } else {
        return "new-audit-color-1";
      }
    } else {
      if (this.isYD && submitStatusForFsk !== 40) {
        //增加富士康特判, 除了已交卷，其他都返回 “-”
        return "status-black";
      } else {
        if ((submitStatus !== 2 && submitStatus !== 5) || costStatus !== 2) {
          return "status-black";
        } else {
          // 如果AI打分字段的显示为 正在打分，那么评估结果字段展示 -
          if (submitStatus === 2 && aiProcessStatus !== 3) {
            return "status-black";
          }

          if (auditStatus === 0) {
            return "new-audit-color-1";
          } else if (auditStatus === 1) {
            return "new-audit-color-2";
          } else if (auditStatus === 2) {
            return "new-audit-color-3";
          } else if (auditStatus === 3) {
            return "new-audit-color-4";
          } else {
            return "new-audit-color-1";
          }
        }
      }
    }
  }

  scoreAiConvert(
    submitStatus: number,
    scoreAi: number,
    aiProcessStatus: number
  ) {
    if (submitStatus === 0 || submitStatus === 1 || submitStatus === 3) {
      return "-";
    } else if (submitStatus === 2 || submitStatus === 4) {
      if (aiProcessStatus !== 3) {
        return "正在打分";
      } else {
        return scoreAi;
      }
    }
  }
  hasFile(row: any) {
    const name = row.column.label;
    const p = row.row.paramList.find((d: any) => d.name === name); //url
    return p.cascadeValue;
  }

  //打开简历
  showAttachment(row: any) {
    const name = row.column.label;
    const p = row.row.paramList.find((d: any) => d.name === name); //url
    const h = window.outerHeight;
    const w = Math.max((window.innerWidth - 840) / 2, 540);
    const left =
      (window.screenX || window.screenLeft || 0) + window.innerWidth - w;
    window.open(
      p.cascadeValue,
      "_blank",
      `height=${h}, width=${w}, top=0, left=${left}, toolbar=no, menubar=no, scrollbars=no,location=no, resizable=yes, directories=yes, status=no`
    );
  }

  auditReasonConvert(auditReason: any) {
    if (auditReason) {
      const t = auditReason.split("\n");
      let h = ``;
      t.forEach((d: string) => {
        if (d.slice(0, 2) === "核心") {
          h += `<span style="color:red">${d.slice(6)}</span><br/>`;
        }
        if (d.slice(0, 2) === "重点") {
          h += `<span>${d.slice(6)}</span><br/>`;
        }
      });
      return h;
    } else {
      return "-";
    }
  }

  scoreConvert(
    submitStatus: number,
    score: number,
    aiProcessStatus: number,
    auditStatus: number
  ) {
    if (this.isEnableAi) {
      // 配置了AI，AI为正在打分中是，得分显示“-” 如果评估完毕，还是要显示真实得分
      if (
        (submitStatus === 0 ||
          submitStatus === 1 ||
          submitStatus === 3 ||
          aiProcessStatus !== 3) &&
        auditStatus !== 1 &&
        auditStatus !== 2 &&
        auditStatus !== 3
      ) {
        return "-";
      } else {
        return score;
      }
    } else {
      // 没配置AI，提交时即可展示得分
      if (submitStatus === 0 || submitStatus === 1 || submitStatus === 3) {
        return "-";
      } else {
        return score;
      }
    }
  }

  submitStatusConvert(submitStatus: number, auditStatus: number) {
    if (submitStatus === 0) {
      return "未登记";
    } else if (submitStatus === 1) {
      return "答题中";
    } else if (submitStatus === 3) {
      return "已登记";
    } else if (submitStatus === 2) {
      return "已交卷";
    } else if (submitStatus === 5) {
      return "已评估";
    } else if (submitStatus === 4) {
      return "待评估";
    } else {
      if (auditStatus === 0) {
        return "待评估";
      } else if (auditStatus === 1) {
        return "通过";
      } else if (auditStatus === 2) {
        return "待定";
      } else if (auditStatus === 3) {
        return "拒绝";
      } else {
        return "待评估";
      }
    }
  }

  submitStatusConvertFsk(submitStatus: number) {
    if (submitStatus == 0) {
      return "未完成";
    } else if (submitStatus == 10) {
      return "未答题";
    } else if (submitStatus == 20) {
      return "无资格";
    } else if (submitStatus == 30) {
      return "未完成";
    } else if (submitStatus == 40) {
      return "已交卷";
    } else {
      return "未完成";
    }
  }

  bgCheckColor(bgCheckStatus: number) {
    if (bgCheckStatus === 1) {
      return "#ff970e";
    } else if (bgCheckStatus === 2) {
      return "#0ad3af";
    } else if (bgCheckStatus === 3) {
      return "#FC1A21";
    } else if (bgCheckStatus === 4) {
      return "#ff970e";
    }
  }

  bgCheckConvert(bgCheckStatus: number) {
    if (bgCheckStatus === 0) {
      return "-";
    } else if (bgCheckStatus === 1) {
      return "未进行";
    } else if (bgCheckStatus === 2) {
      return "通过";
    } else if (bgCheckStatus === 3) {
      return "有异常";
    } else if (bgCheckStatus === 4) {
      return "验证中";
    } else if (bgCheckStatus === 255) {
      return "未配置";
    } else {
      return "-";
    }
  }

  getBgContent(bgCheckStatus: number) {
    if (bgCheckStatus === 0) {
      return "";
    } else if (bgCheckStatus === 4) {
      return "候选人验证中";
    } else if (bgCheckStatus === 255) {
      return "本场面试未选择背调产品";
    } else {
      return "";
    }
  }

  getRepeatList(id: number) {
    if (this.isWorker) {
      // 富士康不让点
      return;
    }
    this.repeatCandidateListForm.candidateId = id;
    this.isShowRepeatModal = true;
  }
  //加载列表
  getCandidateList(flag?: string) {
    if (flag === "toFirst") {
      this.page = 1;
      this.candidateListForm.page = this.page;
    }

    this.tableLoading = true;
    this.candidateListForm.examId = parseInt(this.paperId);
    this.candidateListForm.subExamId = this.subExam as number;
    this.candidateListForm.companyId = parseInt(Auth.companyId);
    this.candidateListForm.pageSize = this.currentPageSize;

    if ([4, 5].includes(this.candidateSubmitStatus)) {
      this.candidateListForm.submitTime = [];
      this.candidateListForm.beginTime = [];
    }

    if (this.candidateSubmitStatus === 3) {
      this.candidateListForm.submitTime = [];
    }

    // 缓存当前的页码值
    Auth.currentPageSize = String(this.currentPageSize);
    // 候选人状态筛选
    if (this.isYD) {
      switch (this.candidateSubmitStatus) {
        case 0: //全部参与
          this.candidateListForm.submitStatusList = [];
          if (this.candidateAuditStatus === 0) {
            this.candidateListForm.auditStatusList = [0, 1, 2, 3];
          } else {
            this.candidateListForm.auditStatusList = [
              this.candidateAuditStatus
            ];
          }
          break;
        case 1: //有效
          this.candidateListForm.submitStatusList = [];
          if (this.candidateAuditStatus === 0) {
            this.candidateListForm.auditStatusList = [1, 2, 3];
          } else {
            this.candidateListForm.auditStatusList = [
              this.candidateAuditStatus
            ];
          }
          break;
        case 2: //无效
          this.candidateListForm.submitStatusList = [];
          this.candidateListForm.auditStatusList = [0];
          this.candidateAuditStatus = 0;
          break;
      }
    } else {
      switch (this.candidateSubmitStatus) {
        case 0: //不限
          this.candidateListForm.submitStatusList = [];
          break;
        // case 1: //已评估
        //   this.candidateListForm.submitStatusList = [2];
        //   this.candidateListForm.auditStatusList = [1, 2, 3];
        //   break;
        // case 2: //待评估
        //   this.candidateListForm.submitStatusList = [2];
        //   this.candidateListForm.auditStatusList = [0];
        //   this.candidateAuditStatus = 0;
        //   break;
        case 2: //已交卷
          this.candidateListForm.submitStatusList = [2];
          this.candidateListForm.auditStatusList = [];
          break;
        case 3: //答题中
          this.candidateListForm.submitStatusList = [1];
          this.candidateListForm.auditStatusList = [];
          this.candidateAuditStatus = 0;
          break;
        case 4: //已登记
          this.candidateListForm.submitStatusList = [3];
          this.candidateListForm.auditStatusList = [];
          this.candidateAuditStatus = 0;
          break;
        case 5: //未登记
          this.candidateListForm.submitStatusList = [0];
          this.candidateListForm.auditStatusList = [];
          this.candidateAuditStatus = 0;
          break;
        default:
          this.candidateListForm.submitStatusList = [];
          this.candidateListForm.auditStatusList = [];
          this.candidateAuditStatus = 0;
          break;
      }
    }
    // 评估结果筛选
    if (
      (this.candidateSubmitStatus === 0 || this.candidateSubmitStatus === 2) &&
      !this.isYD
    ) {
      switch (this.candidateAuditStatus) {
        case 0: //不限
          this.candidateListForm.auditStatusList = [0, 1, 2, 3];
          break;
        case 1: //待评估
          this.candidateListForm.auditStatusList = [0];
          break;
        case 2: //通过
          this.candidateListForm.auditStatusList = [1];
          break;
        case 3: //待定
          this.candidateListForm.auditStatusList = [2];
          break;
        case 4: //拒绝
          this.candidateListForm.auditStatusList = [3];
          break;
        default:
          this.candidateListForm.auditStatusList = [];
          break;
      }
    }
    // ATS面试结果回调筛选
    if (!this.isYD && this.setWeb) {
      switch (this.markCallbackStatus) {
        case 0: // 不限
          this.candidateListForm.markCallbackStatusList = [];
          break;
        case 1: // 未回调
          this.candidateListForm.markCallbackStatusList = [0, 1, 3, 254, 255];
          break;
        case 2: // 已回调
          this.candidateListForm.markCallbackStatusList = [2];
          break;
        default:
          this.candidateListForm.markCallbackStatusList = [];
          break;
      }
    }
    if (this.candidateAuditStatus > 0 && this.candidateSubmitStatus === 0) {
      this.candidateListForm.submitStatusList = []; // [2] -> []
    }
    this.candidateListForm.tagNameList = this.candidateTag;

    if (this.fuzzySearch) {
      this.candidateListForm.searchKeyLike = this.showNameOrPhone;
    } else {
      this.candidateListForm.showNameOrPhone = this.showNameOrPhone;
    }

    this.candidateListForm.aiRecommendStatusList = this.aiRecommendStatus
      ? [this.aiRecommendStatus as number]
      : [];
    if (this.onlyShowSelf) {
      this.candidateListForm.searchUserIdList = [parseInt(this.V.user.id)];
    } else {
      this.candidateListForm.searchUserIdList = [];
    }
    //富士康 今日人数
    if (this.isYD) {
      this.getTodayNum(this.candidateListForm);
    }

    // 批量筛选候选人
    if (this.connectCodeList.length > 0) {
      this.candidateListForm.connectCodeList = this.connectCodeList;
    } else {
      this.candidateListForm.connectCodeList = [];
    }
    //字段信息查询
    this.candidateListForm.paramSearchList = [
      ["第一意向工作城市", this.city1 !== "不限" ? this.city1 : ""],
      ["第二意向工作城市", this.city2 !== "不限" ? this.city2 : ""],
      ["意向部门", this.job !== "不限" ? this.job : ""]
    ];
    this.candidateListForm.afterBuy = this.payStatus;
    this.loadingList = true;
    ExamList[this.isYD ? "getFskCandidateList" : "getCandidateList"](
      this.candidateListForm
    )
      .then(res => {
        this.total = res.data.count;
        this.tableLoading = false;
        this.loadingList = false;
        res.data.list.forEach((listRes: any, index: number) => {
          res.data.list[index].paramList = listRes.paramList.filter(
            (filterRes: any) => {
              return filterRes.isShow === 1;
            }
          );
        });
        this.candidateList = res.data.list;
        this.currentListLength = res.data.list.length;
        this.waitAuditNum =
          res.data.numbers.submitStatusFinishAuditStatusNoAudit;
        this.finishAuditPassNum =
          res.data.numbers.submitStatusFinishAuditStatusPass;
        this.finishAuditWaitNum =
          res.data.numbers.submitStatusFinishAuditStatusWait;
        this.finishAuditRefuseNum =
          res.data.numbers.submitStatusFinishAuditStatusRefuse;
        this.finishAuditNum =
          res.data.numbers.submitStatusFinishAuditStatusPass +
          res.data.numbers.submitStatusFinishAuditStatusWait +
          res.data.numbers.submitStatusFinishAuditStatusRefuse; // 已评估人数为 通过+待定+拒绝
        this.answeringNum = res.data.numbers.submitStatusAnswering;
        this.notansweringNum =
          res.data.numbers.submitStatusNotSignIn +
          res.data.numbers.submitStatusSignIn;
        this.allCandidateNum =
          this.waitAuditNum +
          this.finishAuditNum +
          this.answeringNum +
          this.notansweringNum;
        this.unfinishNum =
          this.waitAuditNum + this.answeringNum + this.notansweringNum;
        this.$nextTick(() => {
          if (!this.selectAllFlag) {
            const multipleTable = this.$refs.multipleTable as any;
            console.log(this.selectedList);
            const closeRow: any = [];
            this.candidateList.forEach((item: any, index) => {
              if (
                this.selectedList.find(
                  el => el.candidateId === item.candidateId
                )
              ) {
                console.log("has", item.candidateId, index);
                // multipleTable.toggleRowSelection(item, true)
              } else {
                closeRow.push(item);
                console.log("not", item.candidateId, index);
                // multipleTable.toggleRowSelection(item, false)
              }
            });
            closeRow.forEach(item => {
              multipleTable.toggleRowSelection(item, false);
            });
          }
        });
      })
      .finally(() => {
        this.tableHeaderChange = false;
        this.loadingList = false;
        // this.candidateIdsLength = 0;
        this.getTagList();
      });
  }
  //今日人数
  getTodayNum(params: any) {
    const t = JSON.parse(JSON.stringify(params));
    t.createdTime = [
      dayjs(new Date()).format("YYYY-MM-DD") + " 00:00:00",
      dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
    ];
    ExamList[this.isYD ? "getFskCandidateList" : "getCandidateList"](t).then(
      res => {
        this.todayPeopleAll = res.data.count;
      }
    );
  }

  addCandidate() {
    this.examGetForm.examId = parseInt(this.paperId);
    this.examGetForm.companyId = parseInt(Auth.companyId);
    ExamList.examGet(this.examGetForm).then(res => {
      this.examName = res.name;
      this.candidateCreateForm.paramList = res.paramList.filter(
        (e: StructParam) => {
          return e.isShow == 1;
        }
      );
    });
    this.isShowAddOne = true;
  }
  handleMSendMessageClose() {
    this.showMSendMessage = false;
  }
  handleRepeatInterviewClose() {
    this.showRepeatInterview = false;
  }
  addCancel() {
    this.isShowAddOne = false;
    this.getCandidateList();
  }
  addSubmit() {
    this.isShowAddOne = false;
    this.getCandidateList();
  }
  handleOneClose() {
    this.isShowAddOne = false;
  }
  editCancel() {
    this.isShowEdit = false;
  }
  editSubmit() {
    this.getCandidateList();
    this.isShowEdit = false;
  }
  handleEditClose() {
    this.isShowEdit = false;
  }
  auditCancel() {
    this.candidateIdsLength = 0;
    this.showAuditDialog = false;
    this.getCandidateList();
  }
  auditSubmit() {
    this.showAuditDialog = false;
    this.candidateIdsLength = 0;
    this.getCandidateList();
  }
  headerCancel() {
    this.showSetting = false;
  }
  headerSubmit() {
    if (this.tempHeaderList.length > 0) {
      this.showHeaderList = this.tempHeaderList;
      this.showHeaderList.sort(function(a: any, b: any) {
        if (a["sort"] < b["sort"]) {
          return -1;
        }
        if (a["sort"] > b["sort"]) {
          return 1;
        }
        return 0;
      });
      // 表头展示 isShow = true的项
      localStorage.setItem(
        this.TableHeaderCachePrefiex,
        JSON.stringify(this.headerList)
      );
    }
    this.tableHeaderChange = true;
    this.showSetting = false;
    // this.tableHeaderChange = false;
    setTimeout(() => {
      this.tableHeaderChange = false;
      this.tableLoading = false;
    }, 1000);
  }
  showError(d: any) {
    let t = ``;
    const list = d.errorInfoList.filter(
      (el: any) => el.task == "bgCheckIdentity" && el.result === 1
    );
    console.log("🚀 ~ d.errorInfoList.forEach ~ d:", d);
    d.errorInfoList.forEach((m: any, n: number) => {
      //异常项 枚举
      if (!errorEnum[m.task]) return;
      if (m.result === 1) {
        // // 手机号实名未通过-背调信息为未查询
        // if (list.length && m.task === "bgCheck") {
        //   t += "候选人背调未查询" + `<br/>`;
        //   return;
        // }
        // 手机号实名不通过，不展示社会、金融风险
        if (
          list.length &&
          (m.task === "bgCheckSocial" || m.task === "bgCheckFinancial")
        ) {
          return;
        }
        if (
          m.task === "bgCheckSocial" &&
          d.bgCheckResult.socialInfoStatus === 3 &&
          d.bgCheckResult.socialInfoErrorLevel > 0
        ) {
          t +=
            `候选人社会安全${
              errorMessageLevel[d.bgCheckResult.socialInfoErrorLevel]
            }` + `<br/>`;
          return;
        }
        if (
          m.task === "bgCheckFinancial" &&
          d.bgCheckResult.financialRiskStatus === 3 &&
          d.bgCheckResult.financialRiskErrorLevel > 0
        ) {
          t +=
            `候选人金融${
              errorMessageLevel[d.bgCheckResult.financialRiskErrorLevel]
            }` + `<br/>`;
          return;
        }
        let errorMessage = errorEnum[m.task];
        if (m.task === "faceCheck") {
          errorMessage = m?.resMessage ? m.resMessage : errorMessage;
        }
        t += (errorMessage || "") + `<br/>`;
        // t += String(n + 1) + "." + errorEnum[m.dask];
      }
    });
    this.errorText = t;
    this.showErrorTitle = "异常情况说明";
    this.showWarningIcon = true;
    this.showErrorInfo = true;
  }
  examMobileJoinCountCheckClick(row: any) {
    this.showErrorTitle = "切屏次数说明";
    this.errorText = `候选人在面试过程中切屏 ${row.mobileJoinCountCheckNumber} 次`;
    this.showWarningIcon = false;
    this.showErrorInfo = true;
  }
  //面试官结果
  getJudgeRes(judge: JudgeResult) {
    if (!judge) return;
    let t = ``;
    judge.judgeNameList.forEach((d, i) => {
      t +=
        `<span style="color:#666666">【` +
        d +
        `】</span>` +
        auditTextEnum[judge.auditStatusList[i]] +
        (judge.auditStatusList[i] !== 0
          ? `:` + (judge.scoreJudge.list[i] + `分`)
          : "") +
        `<br/>`;
    });
    return t;
  }
}
